/* Dynamic Plot code copyright 2015 (c) Tuva Labs Inc. */
/**
 * created by cmiller
 */

import { hasMathJaxPattern } from '../../utils/Util';
import { MarginView } from './topMarginView';
import { DropArea } from './dropArea';
import { PlotViewElements } from "./dragHandler";

export const wrapDynRightMarginView = function(Dyn) {
	let mediator = Dyn.mediator;

    class ExcludedCasesDisplay {

        //static states = ['hide', 'showCustomOrderBy', 'showMissing', 'showFiltered', 'showBoth'];

        constructor( paper, dataSet, plotShaper ) {
            this.dataSet = dataSet; // reference to Dyn.DataSet
            this.plotShaper = plotShaper; // reference to Dyn.PlotShaper
            // this.excludedCasesDisplay = []; // moved from PlotView.excludedCasesDisplay, now see this.missingFilteredSet and this.orderBySet
            this.state = {
                showMissing: false,
                showFiltered: false,
                showCustomOrderBy: false,
            };

            // raphael elements
            this.numMissingText = null;
            this.numFilteredText = null;
            this.missingCircle = null;
            this.filterIcon = null;
            this.excludedCasesRect = null;
            this.missingFilteredSet = null; // set of above 5 elements

            this.orderedByText = null;
            this.orderbySVGTitle = null; // mathjax version of Order-by text, if needed
            this.closeIcon = null;
            this.orderBySet = null; // set of above 3 elements

            this.initVisuals( paper );
        }

        getOrderByTextElement() {
            return this.orderedByText; // shared with PlotView, RightMarginView
        }
        getOrderedByCloseBoxElement() {
            return this.closeIcon; // shared with PlotView, RightMarginView
        }

        initVisuals( paper ) {
            let dataSet = this.dataSet,
                excludedCasesFontSize = Dyn.preferences.getFontSize( Dyn.plotUtil.excludedCasesFontSize );

            paper.setStart();
            this.numMissingText = // [0] is num missing value cases text
                paper.text( 0, 0, "" ).attr( { /*stroke:"gray",*/ "font-size": excludedCasesFontSize } ).hide();
            this.numFilteredText = // [1] is num filtered cases text
                paper.text( 0, 0, "" ).attr( { /*stroke:"gray",*/ "font-size": excludedCasesFontSize } ).hide();
            this.missingCircle = // [2] is missing value icon (circle)
                paper.circle( 0, 0, Dyn.plotUtil.missingCaseIconRadius ).attr( {
                    stroke: "black",
                    fill: "gray"
                } ).hide();
            this.filterIcon = // [3] is filter icon (path)
                paper.path( Dyn.plotUtil.getFilterIcon( Dyn.plotUtil.fileredCaseIconSize ) ).attr( {
                    stroke: "none",
                    fill: "black"
                } ).hide();
            this.excludedCasesRect = PlotViewElements.makeExcludedCasesRect( Dyn, paper, this.dataSet ); // moved from PlotView.excludedCasesRect
            this.missingFilteredSet = paper.setFinish();
            Dyn.assert( this.missingFilteredSet.length === 5 );

            this.orderedByText = // [0] is ordered by attribute text
                paper.text( 0, 0, "" ).attr( { /*stroke:"gray",*/
                    "font-size": excludedCasesFontSize
                } ).data( "tooltip", "" ).hover(
                    function orderByHoverIn( e ) {
                        Dyn.toolTip.show( this, e, { x: this.attrs.x, y: this.attrs.y, alignRight: true } );
                    },
                    function buttonHoverOut( e ) {
                        if( Dyn.toolTip.isMyElement( this ) )
                            Dyn.toolTip.hide();
                    } ).hide();
            this.orderbySVGTitle = null; // [1] mathjax version of Order-by text
            this.closeIcon = Dyn.plotUtil.makeCloseBox( paper, hoverInCloseBox, hoverOutCloseBox, clickedOnClosebox, '',
                Dyn.plotUtil.orderByCloseButtonId, Dyn.plotUtil.roundRectAxisButtonOptions() )
                .data( "tooltip", Dyn.loc( "remove Ordered by" ) )
                .hide(); // [2] is Order by closebox
            this.orderBySet = paper.set();
            this.orderBySet.push( this.orderedByText, this.orderbySVGTitle, this.closeIcon );

            function clickedOnClosebox( /*e */ ) {
                // handler to remove Ordered by {attributename}
                var attributeData = { id: "", name: "", object: "plot" };
                mediator.publish( "records:newOrderByAttribute", attributeData );
            }
            function hoverInCloseBox( e ) {
                e.currentTarget.style.cursor = Dyn.plotUtil.cursorPointer;
                this.attr( { fill: Dyn.plotUtil.axisButtonDownColor, stroke: Dyn.plotUtil.axisButtonDownColor } );
                Dyn.toolTip.show( this, e, { x:this.attrs.x, y:this.attrs.y, alignRight: true });
            }
            function hoverOutCloseBox( e ) {
                e.currentTarget.style.cursor = Dyn.plotUtil.cursorDefault;
                this.attr( { fill: Dyn.plotUtil.axisButtonUpColor, stroke: "none" } );
                if( Dyn.toolTip.isMyElement( this ))
                    Dyn.toolTip.hide();
            }
        }

        updateVisuals( animationTimeMS, rightMarginBounds ) {
            let iconStyler = this.plotShaper.iconStyler,
                numMissing = this.dataSet.missingCases.getNumCasesMissing(),
                numFiltered = this.dataSet.caseFilter.getNumCasesFiltered(),
                oldNumMissing = this.excludedCasesRect.data( "numMissing" ),
                oldNumFiltered = this.excludedCasesRect.data( "numFiltered" ),
                fontSize = Dyn.preferences.getFontSize( Dyn.plotUtil.excludedCasesFontSize ),
                textOffset = fontSize - 0,
                xMiddle = iconStyler.missingValuePosition.x,
                xLeft = xMiddle,
                xRight = xMiddle,
                y = iconStyler.missingValuePosition.y,
                // yIcon = y+2, // offset slightly to align with text
                animate = ( animationTimeMS > 0 && ( numMissing !== oldNumMissing || numFiltered !== oldNumFiltered )),
                opacity = ( animate ? 0 : Dyn.plotUtil.excludedCasesTextOpacity ),
                opacityCloseBox = ( animate ? 0 : 1 ),
                // numMissingText = this.excludedCasesDisplay[0],
                // numFilteredText = this.excludedCasesDisplay[1],
                // missingCircle = this.excludedCasesDisplay[2],
                // filterIcon = this.excludedCasesDisplay[3],
                // orderedByText = this.excludedCasesDisplay[4],
                // closeIcon = this.excludedCasesDisplay[5],
                bbox = new Dyn.mathUtil.Rect(),
                hasLegend = this.dataSet.getSelectedAttribute() !== null,
                orderByAttribute = this.dataSet.getOrderByAttribute();

            // update the state
            this.state.showMissing = (numMissing > 0);
            this.state.showFiltered = ( numFiltered > 0 );
            this.state.showCustomOrderBy = this.plotShaper.hasCustomOrderBy() &&
                !( Dyn.plotUtil.isTuvaJr() && orderByAttribute===this.dataSet.getSelectedAttribute() );

            // Remove the orderbySVGTitle if it is created already
            if(this.orderbySVGTitle) {
                this.orderbySVGTitle.remove();
                this.orderbySVGTitle = null;
                this.orderBySet[1] = this.orderbySVGTitle; // update set
            }

            if( this.state.showCustomOrderBy ) {
                this.orderedByText.data( "tooltip",
                    (this.plotShaper.isCustomOrderForLines() ?
                        Dyn.loc( "Lines ordered by {{attributeName}}", { attributeName:orderByAttribute.name }) :
                        Dyn.loc( "Cases ordered by {{attributeName}}", { attributeName:orderByAttribute.name }))
                );
                let textAttrs = {
                    text: Dyn.loc("Ordered by {{attributeName}}", { attributeName:orderByAttribute.name }),
                    x: xLeft, y: y, opacity: opacity,
                    'text-anchor': "end", 'font-size':fontSize, 'class': 'tde-attribute-name',
                    fill: Dyn.plotUtil.titleColor
                };
                this.orderedByText.attr( textAttrs ).show();
                bbox = this.orderedByText.getBBox();
                let xClose = xLeft, yClose = y;
                if( hasLegend ) {
                    // Order-by text to right of numFiltered and closebox, centered above legend attribute name
                    Dyn.assert(this.closeIcon.getCoverElement().attr("width")>0);
                    xRight += textOffset + 3; /* this.closeIcon.getCoverElement().attr("width")/2;*/ // move to right of filter symbol
                    bbox = Dyn.plotUtil.clipStringToWidth( this.orderedByText, rightMarginBounds.right() - xRight );
                    xRight += (rightMarginBounds.right() - xRight)/2; // to center in legend width
                    this.orderedByText.attr({ x:xRight, "text-anchor":"middle" });
                    // xClose += 2; // align Order-by close box perfectly with Legend close box
                    xLeft -= Dyn.plotUtil.iconSize; // shift filter or missing display to left of close box
                } else {
                    // Order-by text anchored at end, with closebox to right of text
                    xClose = bbox.x + bbox.width + 15;
                    xLeft -= (bbox.width + textOffset );
                }
                xMiddle = xLeft; // middle marks divider between Order-by and Filter display
                this.closeIcon.getSymbolElement().attr({ opacity: opacityCloseBox });
                // update aria label to provide appropriate information for the current order by attribute context
                this.closeIcon[0].node.setAttribute("aria-label",
                    Dyn.stringFormat(Dyn.plotUtil.removeOrderByButtonAriaLabel, orderByAttribute.name));
                this.closeIcon.transform( "t"+xClose+","+yClose);
                Dyn.plotUtil.showOrHideElement( this.closeIcon, ! Dyn.preferences.isViewOnly())

                // Create svg for mathjax and hide the normal text view
                if(hasMathJaxPattern(orderByAttribute.name)) {
                    this.updateOrderedByText( orderByAttribute, textAttrs );
                    this.orderBySet[1] = this.orderbySVGTitle; // update set
                }
            } else {
                this.closeIcon.hide();
                this.orderedByText.hide();
            }

            // update filter display, position to left of missingValuePosition/legend area
            if( this.state.showFiltered ) {
                const yFilter = y+2; // offset slightly to align with text
                this.filterIcon.attr({ opacity: opacity })
                    .transform( "t" + xLeft + "," + yFilter )
                    .show();
                xLeft -= textOffset;
                this.numFilteredText.attr({ text:"-"+numFiltered, x:xLeft, y:y, opacity:opacity, "text-anchor":"end", 'font-size':fontSize } )
                    .show();
                bbox = this.numFilteredText.getBBox();
                xLeft -= (bbox.width + (2 * textOffset ));
            } else {
                this.filterIcon.hide();
                this.numFilteredText.hide();
            }

            // update missing display, position to left of numFiltered
            if( this.state.showMissing ) {
                this.missingCircle.attr({ cx:xLeft, cy:y, opacity: opacity })
                    .show();
                xLeft -= textOffset;
                this.numMissingText.attr({ text:"-"+numMissing, x:xLeft, y:y, opacity:opacity, "text-anchor":"end", 'font-size':fontSize })
                    .show();
                bbox = this.numMissingText.getBBox();
                xLeft -= (bbox.width + textOffset );
            } else {
                this.missingCircle.hide();
                this.numMissingText.hide();
            }

            if( animate ) {
                // animate opacity of missing/filtered display elements from 0 to final opacity
                this.missingFilteredSet.forEach( (el) => {
                    let opacity = (el===this.excludedCasesRect) ? Dyn.plotUtil.opacityInvisibleButDraggable
                            : Dyn.plotUtil.excludedCasesTextOpacity;
                    el.animate( {opacity: opacity }, animationTimeMS, Dyn.plotUtil.stdAnimationEasing );
                });
                // update opacity of order-by display elements, no animation
                this.orderBySet.forEach( (el) => {
                    let opacity = (el===this.closeIcon) ? 1 : Dyn.plotUtil.excludedCasesTextOpacity;
                    el.attr( {opacity: opacity });
                });
            }

            // update cover rectangle for tooltip over count or excluded cases
            let coverRectWidth = ((xMiddle-xLeft)+textOffset),
                hoverAriaText = this._getHoverAndAriaLabel( numMissing, numFiltered );
            this.excludedCasesRect.attr({ x:xLeft, y:bbox.y, height:bbox.height, width: coverRectWidth });
            this.excludedCasesRect.data( "alignRight", true ); // used by excludedCasesHoverOver()
            this.excludedCasesRect.data( "numMissing", numMissing );
            this.excludedCasesRect.data( "numFiltered", numFiltered );
            this.excludedCasesRect.data( 'tooltip', hoverAriaText );
            this.excludedCasesRect.node.setAttribute( 'aria-label', hoverAriaText );
            if( numMissing > 0 || numFiltered > 0 ) {
                this.excludedCasesRect.show();
            } else {
                this.excludedCasesRect.hide();
            }
            if( Dyn.toolTip.isMyElement( this.excludedCasesRect ) )
                Dyn.debugging && console.warn("excludedCasesRect tooltip showing and needs update to:", hoverAriaText );

            // adjust plot title so it doesn't overlap with excluded cases display => MOVED TO PlotView.updateExcludedCasesCount()
        }

        _getHoverAndAriaLabel( numMissing, numFiltered ) {
            // show "n case(s) missing" and/or "n case(s) filtered" tooltip
            let missingCases = caseOrCases( numMissing, false ),
                filteredCases = caseOrCases( numFiltered, true );

            return (missingCases ? missingCases + "\n" : "") + filteredCases;

            function caseOrCases( number, isFilter ) {
                if( number > 0 ) {
                    if( isFilter ) {
                        return (number === 1) ? Dyn.loc( "1 case filtered" ) :
                            Dyn.loc( "{{n}} cases filtered", { n: number } );
                    } else {
                        return (number === 1) ? Dyn.loc( "1 case with missing values" ) :
                            Dyn.loc( "{{n}} cases with missing values", { n: number } );
                    }
                }
                return "";
            }
        }

        updateOrderedByText( orderByAttribute, textAttrs ) {
            let bbox = this.orderedByText.getBBox(),
                fontSize = textAttrs["font-size"];
            this.orderedByText.hide();

            this.orderbySVGTitle = this.orderedByText.paper.g();
            this.orderbySVGTitle.node.style.pointerEvents = "bounding-box";
            this.orderbySVGTitle.data( "tooltip", this.orderedByText.data( "tooltip" ) );
            this.orderbySVGTitle.hover(
                function orderByHoverIn( e ) {
                    Dyn.toolTip.show( this, e, { x:this.attrs.x, y:this.attrs.y, alignRight: true } );
                },
                function buttonHoverOut( e ) {
                    if( Dyn.toolTip.isMyElement( this ))
                        Dyn.toolTip.hide();
                });

            const setSvgTitle = (_svg) => {
                if(!this.orderbySVGTitle.node) {
                    return;
                }
                this.svgCache = {
                    attrname: orderByAttribute.name,
                    svg: _svg
                }
                // Style svg
                _svg.style.fontSize = fontSize;
                _svg.style.fontWeight = "bold";
                _svg.style.color = Dyn.plotUtil.titleColor;
                // Append the svg into the title node
                this.orderbySVGTitle.node.appendChild(_svg);
                // To position it in center of the give x and y position
                this.orderbySVGTitle.attr({
                    transform: 'r0T'+ Math.round(bbox.x) +',' + Math.round(bbox.y),
                    x: Math.round(bbox.x),
                    y: Math.round(bbox.y),
                    width: bbox.width,
                    height: bbox.height
                });
            }

            // If svg cache is available and the attribute name is same, use the cached svg
            // else create new SVG
            if(this.svgCache && this.svgCache.attrname === orderByAttribute.name && this.svgCache.svg) {
                setSvgTitle(this.svgCache.svg);
                Dyn.debugMathJax && console.log("PlotView.updateExcludedCasesCount: using cached svg '", orderByAttribute.name, "'");
            } else {
                Dyn.axisUtil.mathJaxTxtToSVG(Dyn.loc("Ordered by {{attributeName}}", { attributeName:orderByAttribute.name }), setSvgTitle);
            }
        }

        layerVisuals( layerNum ) {
            switch( layerNum ) {
                case 0:
                    this.missingFilteredSet.forEach( el => el?.toFront() );
                    break;
                case 1:
                    this.orderBySet.forEach( el => el?.toFront() );
                    break;
            }
        }

    } // class ExcludedCasesDisplay
    Dyn.ExcludedCasesDisplay = ExcludedCasesDisplay;

    class OrderDropArea extends DropArea {
        constructor( Dyn, axisID, plotShaper ) {
            super( Dyn, axisID );
            this.plotShaper = plotShaper; // reference to plot shaper
        }

        // caller sets the drop area height to use, to match the excluded cases display
        setExcludedCasesHeight( height ) {
            this.stdHeight = height;
        }

        calcHeight() {
            return this.wantVisible() ? this.stdHeight : 0;
        }

        wantVisible() {
            return this.plotShaper.allowCustomOrderBy();
        }

        isVisible() {
            return this.stdHeight > 0; // true if we have a non-empty drop area after updateVisuals()
        }

        layerVisuals( layerNum ) {
            switch( layerNum ) {
                case 0: this.dropRect.toFront(); break;
                case 1: break;
                case 2: this.dropRectOverlay.toFront(); break;
            }
        }
    }

    class BubbleDropArea extends DropArea {
        constructor( Dyn, axisID, plotShaper ) {
            super( Dyn, axisID );
            this.plotShaper = plotShaper; // reference to plot shaper
            this.bubbleLegend = null; // set which holds the legend elements
            this.title = null; // bubble legend title element, also part of .bubbleLegend set
            this.closebox = null; // closebox for bubble legend
        }

        initVisuals( paper, bounds, viewAreaID, marginView ) {
            let Dyn = this.Dyn,
                bubble = this;
            super.initVisuals( paper, bounds, viewAreaID, marginView );
            Dyn.axisUtil.initTextOrMathJaxElement( this, paper ); // init .title, .titleAttrs, .svgCache

            const //buttonSize = Dyn.plotUtil.getTouchAdjustedSize( Dyn.plotUtil.iconSize ),
                buttonOptions = Dyn.plotUtil.roundRectAxisButtonOptions();
            this.closebox = Dyn.plotUtil.makeCloseBox(
                paper, hoverInClosebox, hoverOutClosebox, clickedOnClosebox ,
                Dyn.loc(Dyn.plotUtil.promptBubbleLegendCloseButtonAriaLabel),
                Dyn.plotUtil.bubbleLegendViewCloseButtonId,
                buttonOptions );

            function hoverInClosebox( e ) {
                let cover = bubble.closebox.getCoverElement();
                cover.attr({ fill: Dyn.plotUtil.axisButtonBgDownColor });
                this.attr( { fill: Dyn.plotUtil.axisButtonDownColor, stroke: Dyn.plotUtil.axisButtonDownColor } );
                let bbox = this.getCoverElement().getBBox();
                if( this.data("tooltip"))
                    Dyn.toolTip.show( this, e, { x:bbox.x, y:bbox.y2, alignRight: true });
            }
            function hoverOutClosebox( e ) {
                let cover = bubble.closebox.getCoverElement();
                cover.attr({ fill: Dyn.plotUtil.axisButtonBgUpColor });
                this.attr( { fill: Dyn.plotUtil.axisButtonUpColor, stroke: "none" } );
                if( Dyn.toolTip.isMyElement( this ))
                    Dyn.toolTip.hide();
            }
            function clickedOnClosebox( /*e */ ) {
                // handler to remove Bubble Size by {attributename} from the legend
                mediator.publish( "records:newBubbleByAttribute", {} );
            }
        }

        layerVisuals( layerNum ) {
            switch( layerNum ) {
                case 0:
                    this.dropRect.toFront();
                    break;
                case 1:
                    this.bubbleLegend?.toFront();
                    this.title?.toFront();
                    this.closebox?.toFront();
                    break;
                case 2:
                    this.dropRectOverlay.toFront();
                    break;
            }
        }

        updateVisuals( bounds, fillColor, strokeColor, strokeOpacity, fillOpacity, rightMarginView ) {
            // DropArea.updateVisuals() positions and colors the bubble drop rect
            super.updateVisuals( bounds, fillColor, strokeColor, strokeOpacity, fillOpacity );

            let bubblePlotElement = this.plotShaper.findElement( Dyn.EPlotControl.kControlsBubbles ),
                hasValidBubbleAttr = bubblePlotElement?.hasValidBubbleAttribute();
            if( hasValidBubbleAttr ) {
                // draw the bubble attribute name and legend
                let bubbleAttr = bubblePlotElement?.getBubbleAttribute(),
                    hasValidRange = bubbleAttr && bubbleAttr.stats && Number.isFinite( bubbleAttr.stats.min ),
                    tipText1 = Dyn.loc('Bubble Size by {{attributename}}', {"attributename": bubbleAttr?.name }),
                    tipText2 = tipText1 + ' (' + bubbleAttr?.valueToString(bubbleAttr.stats.min) + ' to ' + bubbleAttr?.valueToString(bubbleAttr.stats.max) + ')';
                rightMarginView.updateAttributeTitle( bubbleAttr, this, tipText1 ); // show bubble attribute name (in this.title)
                if( hasValidRange ) { // only show legend if the current filter gives a valid range
                    this.bounds.height = this.makeBubbleLegend( bubbleAttr, tipText2 ); // update this.bubbleLegend set
                    this.dropRect.attr( { height: this.bounds.height } ); // update drop area size
                }
                Dyn.assert( this.isVisible() && this.bounds.height > 0);
            } else if( bubblePlotElement ) {
                // show prompt: update the title and closebox position
                const buttonSize = Dyn.plotUtil.getTouchAdjustedSize( Dyn.plotUtil.iconSize );
                rightMarginView.updatePromptTitle( this, Dyn.plotUtil.axisButtonSpacing + buttonSize, this.bubblePrompt );
                if( this.bubbleLegend ) {
                    this.bubbleLegend.remove();
                    this.bubbleLegend = null;
                }
                Dyn.assert( this.isVisible() && this.bounds.height > 0);
            } else {
                // remove bubble legend
                Dyn.plotUtil.hideElementAndToolTip( this.title );
                Dyn.plotUtil.hideElementAndToolTip( this.closebox );
                if( this.bubbleLegend ) {
                    this.bubbleLegend.remove();
                    this.bubbleLegend = null;
                }
            }
        }

        get bubblePrompt() {
            return this.Dyn.loc(Dyn.plotStrings.promptValue);
        }

        updateButtons( closeXY ) {
            let bubblePlotElement = this.plotShaper.findElement( Dyn.EPlotControl.kControlsBubbles ),
                hasValidBubbleAttr = bubblePlotElement?.hasValidBubbleAttribute(),
                bubbleAttr = bubblePlotElement?.getBubbleAttribute();
            if( hasValidBubbleAttr ) {
                this.closebox.data( "tooltip", Dyn.loc( "remove {{title}}", { title: bubbleAttr?.name }));
                this.closebox.transform( "t" + closeXY.x + "," + closeXY.y );
                this.closebox.show();
            } else if( bubblePlotElement ) {
                const buttonSize = Dyn.plotUtil.getTouchAdjustedSize( Dyn.plotUtil.iconSize ),
                    promptBBox = this.title.getBBox(Dyn.plotUtil.textBBoxAfterTransform);
                this.closebox.data( "tooltip", Dyn.loc( "remove {{title}}", { title: this.bubblePrompt }));
                this.closebox.transform( "t" + promptBBox.cx + "," + (promptBBox.y - Dyn.plotUtil.axisButtonSpacing - buttonSize/2) );
                this.closebox.show();
            } else {
                this.closebox.hide();
            }
        }

        /** make a bubble legend for the given bubble attribute, and adjust the boundary height */
        makeBubbleLegend( bubbleAttr, tipText ) {
            let Dyn = this.Dyn,
                paper = this.dropRect.paper,
                iconStyler = this.plotShaper.iconStyler;

            // remove the old legend display
            if( this.bubbleLegend ) {
                Dyn.plotUtil.removeElementAndToolTip( this.bubbleLegend );
                this.bubbleLegend = null;
            }
            this.bubbleLegend = paper.set();

            // create the Bubble Legend
            // version C: show the largest bubble, centered below the bubble attribute name
            // TODO: use the proper icon for the bubble, and multiple icons if multiple attributes each with an icon
            // e.g. see Dyn.axisUtil.updateColorRect() for how to use multiple icons
            const ySpacer = 10; // space between bubbles
            let height = this.title.getBBox().height + ySpacer, // start below title
                x = this.bounds.centerX(),
                y = this.bounds.y + height; // start below title
            height += makeBubble( this.bubbleLegend, bubbleAttr.stats.max );
            y = this.bounds.y + height;
            height += makeBubble( this.bubbleLegend, (bubbleAttr.stats.min+bubbleAttr.stats.max)/2 );
            y = this.bounds.y + height;
            height += makeBubble( this.bubbleLegend, bubbleAttr.stats.min );
            let clipRectString = ''+this.bounds.x+','+this.bounds.y+','+this.bounds.width+','+(this.bounds.y + height);
            this.bubbleLegend.attr({ 'clip-rect': clipRectString });
            return height;

            function makeBubble( set, attrValue ) {
                let r = iconStyler.getBubbleRadius( attrValue, bubbleAttr.stats.max ),
                    tipText = ''+bubbleAttr?.name+": "+bubbleAttr?.valueToString(attrValue),
                    bubbleEl, path;
                switch( iconStyler.style ) {
                    case Dyn.EIconStyle.kCustomIcon:
                        path = iconStyler.calcCustomIconPath( x, y + r, r );
                        bubbleEl = paper.path( path );
                        break;
                    case Dyn.EIconStyle.kVariableIcon:
                        let attributeNum = 0; // TODO: make an icon for each attribute in plot
                        path = iconStyler.calcVariableIconPath( x, y + r, r, attributeNum );
                        bubbleEl = paper.path( path );
                        break;
                    default:
                        bubbleEl = paper.circle( x, y + r, r );
                }
                bubbleEl.attr({
                            stroke: 'gray',
                            fill: 'lightgray' })
                        .data( 'tooltip', tipText )
                        .hover( (e) => {
                            Dyn.toolTip.show( bubbleEl, e, { /*x: x, y: y,*/ alignRight: true } );
                        }, (e) => {
                            if( Dyn.toolTip.isMyElement( bubbleEl ) )
                                Dyn.toolTip.hide();
                        });
                set.push( bubbleEl );
                return r*2 + ySpacer; // add size of circleEl + bottom margin
            }
        }

        // _oneBubble( paper, x, y, r, color, tooltip ) {
        //
        // }

        /** remove and hide the bubble legend and title */
        // removeBubbleLegend() {
        //     let Dyn = this.Dyn;
        //     Dyn.plotUtil.hideElementAndToolTip( this.title );
        //     Dyn.plotUtil.hideElementAndToolTip( this.closebox );
        //     if( this.bubbleLegend ) {
        //         this.bubbleLegend.remove();
        //         this.bubbleLegend = null;
        //     }
        //     // return this.wantVisible() ? this.stdHeight : 0; // update height of this drop area
        // }

        calcHeight( containerHeight ) {
            // note: containerHeight is the height of the entire right margin; ignore .stdHeight for now
            this.stdHeight = Math.max( 0, containerHeight/2 ); // default to half the height of the right margin
            this.Dyn.assert( this.stdHeight > 0 );
            return this.wantVisible() ? this.stdHeight : 0;
        }

        getDropRectFillColor( dropState ) {
            let bubblePlotElement = this.plotShaper.findElement( Dyn.EPlotControl.kControlsBubbles ),
                hasValidBubbleAttribute = bubblePlotElement?.hasValidBubbleAttribute(),
                isIncompleteAxis = ! hasValidBubbleAttribute,
                isPrompting = bubblePlotElement && ! hasValidBubbleAttribute;
            return super.getDropRectFillColor( isIncompleteAxis, isPrompting, dropState );
        }

        getDropRectFillOpacity( dropState, draggedAttr ) {
            // Dyn.DropState.isValid( dropState );
            let bubblePlotElement = this.plotShaper.findElement( Dyn.EPlotControl.kControlsBubbles ),
                hasValidBubbleAttribute = bubblePlotElement?.hasValidBubbleAttribute(),
                isUsingPromptTitle = bubblePlotElement && ! hasValidBubbleAttribute,
                isDraggingAttribute = draggedAttr && draggedAttr.isValid();
            return super.getDropRectFillColor( hasValidBubbleAttribute, isUsingPromptTitle, isDraggingAttribute );
        }

        wantVisible() {
            // if there is a plot that uses bubbles, show the bubble drop area in the legend (reserve space vertically)
            return this.plotShaper.hasElement( Dyn.EPlotControl.kControlsBubbles );
        }

        wantExpanded() {
            // if there is a valid bubble attribute, show the bubble legend (expand legend horizontally)
            let bubblePlotElement = this.plotShaper.findElement( Dyn.EPlotControl.kControlsBubbles );
            return Boolean( bubblePlotElement?.hasValidBubbleAttribute());
        }

        isVisible() {
            return this.bounds.height > 0;
        }
    }

    class ColorDropArea extends DropArea {
        constructor( Dyn, axisID, plotShaper ) {
            super( Dyn, axisID );
            this.plotShaper = plotShaper; // reference to plot shaper
            this.title = null; // color legend title element
        }

        initVisuals( paper, bounds, viewAreaID, marginView ) {
            let Dyn = this.Dyn;
            super.initVisuals( paper, bounds, viewAreaID, marginView );
            Dyn.axisUtil.initTextOrMathJaxElement( this, paper ); // init .title, .titleAttrs, .svgCache
        }

        layerVisuals( layerNum ) {
            switch( layerNum ) {
                case 0:
                    this.dropRect.toFront();
                    break;
                case 1:
                    this.title?.toFront();
                    break;
                case 2:
                    this.dropRectOverlay.toFront();
                    break;
            }
        }

        wantExpanded( colorAttribute ) {
            return Boolean( colorAttribute )
        }

        // calcHeight() {
        //     return this.plotShaper.hasElement( Dyn.EPlotControl.kControlsBubbles ) ? this.stdHeight : 0;
        // }
    }

    /************************************************
     * Dyn.RightMarginView()
     *
     * The Right Margin of the plot is the area displaying the Legend and/or right-hand gutter of plot.
     * NOTE: set Dyn.debugViewRects = true to show visual boundaries
     */
    class RightMarginView extends MarginView {

        constructor( w, h, plotPaper, plotShaper, excludedCases ) {
            super();
            this.bounds = new Dyn.mathUtil.Rect( 0, 0, w, h );
            this.isHorizontal = false;
            this.isUsingPromptTitle = ! Dyn.plotUtil.isDrawOnly();
            this.dragData = {};
            this.needsLegendUpdate = true;
            this.isUsingPlusMinus = false;
            this.isUsingNumericIntervals = false;
            this.attribute = null; // for getColorAttribute(), used by color legend
            this.axisID = 'right';

            // TODO: move these to this.colorDropArea.state
            // this.isUsingPromptTitle
            // this.isIncompleteAxisStyle
            // this.isDisabledAttribute
            // this.isUsingNumericIntervals ?
            // isUsingPlusMinus ?

            // sizes
            this.legendFontSize = 14;
            this.legendColorSquare = 10;
            this.legendNumericTickLength = 3;
            this.legendMinorTickLength = 1;
            this.showMinorTickMarks = false;
            this.legendNumericTickToTextSpace = 7;
            this.minNumTicks = 3;
            this.pixelsPerTick = 70; // tick mark approx. every x pixels
            this.spacer = 5; // white space around visible elements
            this.dragLineWidth = 7; // width of invisible drag area around boundaryLine
            this.legendThickness = Dyn.plotUtil.kLegendStdThickness; // variable view width when an attribute is displayed
            this.legendRange = null; // range of the drag line for aria-valuenow, aria-valuemin, aria-valuemax

            // Raphael elements
            this.paper = plotPaper;
            // this.title = null;
            this.closebox = null;
            this.scrollbar = null; // hidden unless list of categories is long
            this.boundaryLine = null;
            this.dragLine = null;
            this.plusButton = null;
            this.minusButton = null;
            this.dropRect = null;
            this.dropRectOverlay = null;
            this.glowElement = null;
            this.gradientOverlay = null; // invisible drag area over numeric gradient
            this.marqueeSelectRect = null; // visible only if numeric selection over gradient
            this.attributeLegend = null; // set which holds the legend elements

            this.colorDropArea = new ColorDropArea( Dyn, 'color', plotShaper  );
            this.orderDropArea = new OrderDropArea( Dyn, 'order', plotShaper );
            this.bubbleDropArea = new BubbleDropArea( Dyn, 'bubble', plotShaper );
            this.excludedCases = excludedCases; // reference to Dyn.ExcludedCasesDisplay
        }

        // #2139 as of v3.1.1 thickness of right margin with no legend is now constant
        // get nonLegendThickness() { return Dyn.plotUtil.kMinAxisThickness }

        save() {
            let marginModel = {
                legendThickness: this.legendThickness,
            };
            if( this.isUsingPromptTitle ) {
                marginModel.isUsingPromptTitle = this.isUsingPromptTitle;
            }
            return marginModel;
        }

        restore( savedData ) {
            // #1415 restore legendThickness
            if( Number.isFinite( savedData.legendThickness )) {
                this.legendThickness = savedData.legendThickness;
            }
            // #2139 as of v3.1.1 thickness of right margin with no legend is now constant;
            //      old parameters savedData.nonLegendThickness are ignored.
            // #1335 clear default "PromptTitle" on restore unless savedData.isUsingPromptTitle === true
            this.isUsingPromptTitle = Boolean( savedData.isUsingPromptTitle && ! Dyn.plotUtil.isDrawOnly() );
        }

        initVisuals( titleString ) {

            function canDragLine() { // see also showHideBoundaryLine()
                return marginView.bubbleDropArea.wantExpanded() || marginView.colorDropArea.wantExpanded( marginView.attribute);
            }

            function lineHoverIn( e ) {
                if( canDragLine()) {
                    this.data( 'inHover', true );
                    e.currentTarget.style.cursor = Dyn.plotUtil.cursorHorizontalBothSide;
                    this.attr( { stroke: RightMarginView.legendCoverHighlightColor, 'stroke-opacity':RightMarginView.legendCoverHighlightOpacity } );
                    // marginView.showHideBoundaryLine();
                }
            }
            function lineHoverOut( e ) {
                this.removeData( 'inHover' );
                e.currentTarget.style.cursor = Dyn.plotUtil.cursorDefault;
                if( ! this.data('inDrag')) {
                    this.attr({stroke:RightMarginView.legendCoverColor});
                    // marginView.showHideBoundaryLine();
                }
            }
            function movedLine( dx /*,dy, x, y, e*/ ) {
                if( canDragLine()) {
                    let oldWidth = this.data( 'width' ),
                        newWidth = oldWidth - dx,
                        marginData = {
                            "isHorizontal": (marginView.isHorizontal),
                            oldWidth: oldWidth,
                            newWidth: newWidth
                        };
                    // tell plot view to update (this.postCalcAxisUpdate() calls calcThickness())
                    marginView.legendThickness = newWidth;
                    mediator.publish( "marginView:dragBoundary", marginData );
                }
            }
            function startDragLine( /*x, y, e */ ) {
                if( canDragLine()) {
                    this.data( 'inDrag', true );
                    this.data( 'width', marginView.bounds.width );
                    this.attr( { stroke: RightMarginView.legendCoverHighlightColor, 'stroke-opacity':RightMarginView.legendCoverHighlightOpacity } );
                    // marginView.showHideBoundaryLine();
                }
            }
            function endDragLine( /*e */ ) {
                if( canDragLine()) {
                    this.removeData( 'inDrag' );
                    this.removeData( 'width' );
                    if( !this.data( 'inHover' ) ) {
                        this.attr( { stroke: RightMarginView.legendCoverColor } );
                        // marginView.showHideBoundaryLine();
                    }
                    Dyn.plotUtil.setAsKeyboardFocus( this );
                }
            }
            function hoverInClosebox( e ) {
                let cover = marginView.closebox.getCoverElement();
                cover.attr({ fill: Dyn.plotUtil.axisButtonBgDownColor });
                this.attr( { fill: Dyn.plotUtil.axisButtonDownColor, stroke: Dyn.plotUtil.axisButtonDownColor } );
                let bbox = this.getCoverElement().getBBox();
                if( this.data("tooltip"))
                    Dyn.toolTip.show( this, e, { x:bbox.x, y:bbox.y2, alignRight: true });
            }
            function hoverOutClosebox( e ) {
                let cover = marginView.closebox.getCoverElement();
                cover.attr({ fill: Dyn.plotUtil.axisButtonBgUpColor });
                this.attr( { fill: Dyn.plotUtil.axisButtonUpColor, stroke: "none" } );
                if( Dyn.toolTip.isMyElement( this ))
                    Dyn.toolTip.hide();
            }
            function clickedOnClosebox( /*e */ ) {
                // handler to remove attribute or prompt on click title
                marginView.isUsingPromptTitle = false;
                if( marginView.attribute ) {
                    var attributeData = { id: "", name: "", object: "plot" };
                    mediator.publish( "records:attributeNameSelected", attributeData );
                } else {
                    marginView.updateVisuals();
                }
            }
            function keyDownHandler( e ) {
                //console.log( "keyDownHandler keydown:", e.key );
                switch( e.key ) { // const {key} = event; ES6+
                case "Delete":
                case "Backspace":
                    clickedOnClosebox();
                    break;
                //case "Enter":
                //    break;
                case "ArrowLeft":
                case "ArrowRight":
                case "ArrowUp":
                case "ArrowDown": if( canDragLine() ) {   // move this element one pixel in arrow's direction
                    let dist = Dyn.plotUtil.arrowKeyAcceleratedDistance( e.key ),
                        dragLine = this;
                    startDragLine.call( dragLine, e );
                    movedLine.call( dragLine, dist.dx, dist.dy, undefined, undefined, e );
                    endDragLine.call( dragLine, e );
                }
                    break;
                }
            }

            function makeNumericSelectionRange( view, y1, y2, event, element ) {
                // create or update the visible marquee selection of the numeric gradient, from mouse position
                let dd = view.dragData,
                    py1 = Dyn.plotUtil.dragEventXYtoPaperXY( 0, y1, event, view.paper ).y,
                    py2 = Dyn.plotUtil.dragEventXYtoPaperXY( 0, y2, event, view.paper ).y;
                dd.viewRange = (new Dyn.mathUtil.Range( py1, py2)).normalize();
                dd.dataRange = (new Dyn.mathUtil.Range(
                        dd.coordMap.inverseTransform( dd.viewRange.min ),
                        dd.coordMap.inverseTransform( dd.viewRange.max ))).normalize();
                view.showMarqueeSelectRect( dd.viewRange.min, dd.viewRange.max );
                // update all views with new case selection, if any, including this view.updateVisuals()
                mediator.publish( "records:casesSelectedByNumericRange", dd );
            }
            function dragGradientMove( dx, dy, x, y, event ) {
                makeNumericSelectionRange( marginView, y-dy, y, event, this );
                Dyn.plotUtil.safeStopPropogation( event );
            }
            function dragGradientStart( x, y, event ) {
                marginView.dragData.attributeID = marginView.getColorAttribute().id;
                makeNumericSelectionRange( marginView, y, y, event, this );
                Dyn.plotUtil.safeStopPropogation( event );
            }
            function dragGradientEnd( /*e */ ) {
                Dyn.plotUtil.safeStopPropogation( event );
            }
            function dragGradientHoverIn() {
                Dyn.plotView.plotShaper.prepareElementsForDrag( true );
            }
            function dragGradientHoverOut() {
                Dyn.plotView.plotShaper.prepareElementsForDrag( false );
            }

            var marginView = this;

            // init right margin
            this.orderDropArea.initVisuals( this.paper, this.bounds, Dyn.plotUtil.orderByViewAreaId, marginView );
            this.bubbleDropArea.initVisuals( this.paper, this.bounds, Dyn.plotUtil.bubbleViewAreaId, marginView );
            this.colorDropArea.initVisuals( this.paper, this.bounds, Dyn.plotUtil.legendViewAreaId, marginView );
            this.dropRect = this.colorDropArea.dropRect;
            this.dropRectOverlay = this.colorDropArea.dropRectOverlay;

            this.scrollbar = new Dyn.PlotScrollbar( this.paper, false /*vertical orientation*/,
                                function() { marginView.updateVisuals(); } );

            // NOTE: plot view now updates the margin view, so it does not need to listen directly
            //mediator.subscribe( "records:setSelectedAttribute", this.handleSelectedAttribute );
            // specify the drop rect
            // add the listener to clear the rect, and based on the type of the attribute selected
            // either gradient or categories.

            const pathStr = this._verticalPathLine( this.bounds.x+this.spacer, this.bounds.y+this.spacer, this.bounds.height-(this.spacer*2) );
            this.boundaryLine = this.paper.
                path( pathStr ).
                attr({stroke:RightMarginView.legendBorderColor} ).
                hide(); // hide until we have a selected attribute
            this.dragLine = this.paper.
                path( pathStr ).
                attr({stroke:RightMarginView.legendCoverColor, "stroke-width":Dyn.plotUtil.getTouchAdjustedSize( this.dragLineWidth ), "stroke-opacity":RightMarginView.legendCoverOpacity } ).
                hover( lineHoverIn, lineHoverOut ).
                drag( movedLine, startDragLine, endDragLine ).
                hide(); // hide until we have a selected attribute
            this.dragLine.node.setAttribute( 'role', "separator" );
            this.dragLine.node.setAttribute( 'aria-label', "Separator between plot area and legend" );
            Dyn.plotUtil.setKeyboardFocusable( this.dragLine, keyDownHandler.bind( this.dragLine ));

            // const buttonSize = Dyn.plotUtil.getTouchAdjustedSize( Dyn.plotUtil.iconSize ),
            const buttonOptions = Dyn.plotUtil.roundRectAxisButtonOptions();
            this.closebox = Dyn.plotUtil.makeCloseBox(
                    this.paper, hoverInClosebox, hoverOutClosebox, clickedOnClosebox ,
                    Dyn.loc(Dyn.plotUtil.promptLegendCloseButtonAriaLabel), Dyn.plotUtil.colorLegendViewCloseButtonId,
                buttonOptions );
            this.plusButton  = Dyn.axisUtil.makePlusMinusButton( this, "plusButton",
                Dyn.loc("increase number of bins"), Dyn.plotUtil.legendPlusButtonId );
            this.minusButton = Dyn.axisUtil.makePlusMinusButton( this, "minusButton",
                Dyn.loc("decrease number of bins"), Dyn.plotUtil.legendMinusButtonId );
            this.marqueeSelectRect = this.paper.rect( 0, 0, 0, 0 ).
                attr({ fill:"none", stroke:"#000" /*, "stroke-dasharray":"5,5"*/} ).hide();

            // Overlay element to listen events
            this.gradientOverlay = this.paper.rect( 0, 0, 0, 0 )
                .attr({ fill:"white" , stroke: "blue",
                    opacity: Dyn.plotUtil.opacityInvisibleButDraggable,
                    cursor:Dyn.plotUtil.cursorPointer})
                .drag( dragGradientMove, dragGradientStart, dragGradientEnd )
                .hide();
            // this.dropRectOverlay = this.paper.rect( this.bounds.x, this.bounds.y, this.bounds.width, this.bounds.height, 0 )
            //     .attr({ fill:"white" , stroke: "none", opacity: Dyn.plotUtil.opacityInvisibleButDraggable })
            //     .hide();
            if(!Dyn.environment.isTouchDevice()) {
                // // attribute drag and drop event handlers
                // this.dropRectOverlay.mouseover(function() {
                //     marginView.mouseOverDroppableAreas();
                // });
                // this.dropRectOverlay.mouseout(function() {
                //     marginView.mouseOutDroppableAreas();
                // });
                // this.dropRectOverlay.mouseup(function() {
                //     marginView.mouseUpHandler();
                // });
                this.gradientOverlay.hover( dragGradientHoverIn, dragGradientHoverOut );
            }

            Dyn.addSubcribersToClean(
                mediator.subscribe( "records:setCasesSelected", (data) => {
                    this.handleCasesSelected(data); }));
        }

        setFocus() {
            let firstVisibleElement = [
                    this.dragLine,
                    this.excludedCases.getOrderedByCloseBoxElement()?.getCoverElement(),
                    this.minusButton.getCoverElement(),
                    this.plusButton.getCoverElement(),
                    this.bubbleDropArea.closebox?.getCoverElement(),
                    this.closebox.getCoverElement(), // for color legend
                    ].find((e) => Dyn.plotUtil.isElementVisible(e));
            firstVisibleElement?.node.focus();
        }

        /**
         * Layer the graphical elements from back to front (z-axis), even if hidden.
         * This also sets the keyboard focus order, first to last, for focusable elements.
         */
        layerVisuals( layerNum=0) {
            Dyn.assert( layerNum >= 0 && layerNum <= 2 );
            if( layerNum===0 || layerNum===1 ) {
                this.dropAreas().forEach( a => a.layerVisuals(0)); // drop rects (provide a color background when dragging attributes)
                Dyn.assert( ! this.title );
                this.boundaryLine?.toFront(); // visible line is not a keyboard focus, and is behind closebox in z-order
                this.dragLine?.toFront(); // keyboard focus element 1, if not hidden (otherwise invisible
                this.excludedCases.layerVisuals(1); // OrderBy title and closebox (focus element 2)
                this.minusButton?.toFront(); // keyboard focus element 3, if not hidden
                this.plusButton?.toFront();  // keyboard focus element 4, if not hidden
                this.dropAreas().forEach( a => a.layerVisuals(1)); // bubble and color drop area titles, bubble closebox (keyboard focus element 5 if not hidden)
                // this.orderDropArea.layerVisuals(); // order drop rect (Note: order text is part of ExcludedCasesDisplay)
                // this.bubbleDropArea.layerVisuals(); // bubble legend, title, and closebox (keyboard focus element 4 if not hidden)
                this.closebox?.toFront() // keyboard focus element 6, if not hidden
                // this.colorDropArea.layerVisuals(); // color legend title
                this.attributeLegend?.toFront();
                this.gradientOverlay.toFront();
                this.marqueeSelectRect.toFront();
                this.scrollbar.toFront();
            }
            if( layerNum===2 ) {
                // only show the drop rect overlay when dragging an attribute
                Dyn.assert( this.draggedAttr );
                this.dropAreas().forEach( a => a.layerVisuals(2));
            }
        }

        /**
         * Given a new bounding box, or new attribute, update the visual elements to match.
         */
        updateVisuals() {
            let orderByHeight   = Math.max(0, this.orderDropArea.calcHeight() ),
                bubbleByHeight1  = Math.max(0, this.bubbleDropArea.calcHeight( this.bounds.height ) ),
                viewOnly = Dyn.preferences.isViewOnly(),
                buttonSize = Dyn.plotUtil.getTouchAdjustedSize( Dyn.plotUtil.iconSize ),
                closeXY = { x:this.bounds.x + this.spacer, y:this.bounds.y + (0.5 * buttonSize) - 2 },
                plusXY = { x:closeXY.x - (buttonSize+Dyn.plotUtil.plotButtonSpacing), y:closeXY.y },
                minusXY = { x:plusXY.x - (buttonSize+Dyn.plotUtil.plotButtonSpacing), y:plusXY.y };
            Dyn.assert( ! this.title ); // we now use this.colorDropArea.title

            // add order-by drop area above color or bubble drop area, over "order by" display
            this.orderDropArea.updateVisuals(
                new Dyn.mathUtil.Rect( this.bounds.x, this.bounds.y - orderByHeight, this.bounds.width, orderByHeight ),
                this.orderDropArea.getDropRectFillColor(),
                this.isUsingPromptTitle? Dyn.plotUtil.promptDropStrokeColor: Dyn.plotUtil.normalDropColor,
                this.getDropRectStrokeOpacity(), 0 /*this.getDropRectFillOpacity()*/ );

            // add bubble drop area, if needed, above color drop area, over "bubble size" display
            this.bubbleDropArea.updateVisuals(
                new Dyn.mathUtil.Rect( this.bounds.x, this.bounds.y, this.bounds.width, bubbleByHeight1 ),
                this.bubbleDropArea.getDropRectFillColor(),
                this.isUsingPromptTitle? Dyn.plotUtil.promptDropStrokeColor: Dyn.plotUtil.normalDropColor,
                this.getDropRectStrokeOpacity(), this.bubbleDropArea.getDropRectFillOpacity(), this );
            this.bubbleDropArea.updateButtons( closeXY ); // show/hide/update bubble closebox

            // add color drop area below bubble drop area, over "color by" display
            let bubbleByHeight2 = this.bubbleDropArea.bounds.height,
                colorByHeight = Math.max(0, this.getAdjustedHeight() - bubbleByHeight2);
            closeXY.y += bubbleByHeight2;
            this.colorDropArea.updateVisuals(
                new Dyn.mathUtil.Rect( this.bounds.x, this.bounds.y+bubbleByHeight2, this.bounds.width, colorByHeight ),
                this.getDropRectFillColor(),
                this.isUsingPromptTitle? Dyn.plotUtil.promptDropStrokeColor: Dyn.plotUtil.normalDropColor,
                this.getDropRectStrokeOpacity(), this.getDropRectFillOpacity() );
            Dyn.assert( Dyn.dataSet.getSelectedAttribute() === this.attribute );

            // update the boundaryLine position
            const pathStr = this._verticalPathLine( this.bounds.x+this.spacer, this.bounds.y+buttonSize, this.bounds.height - (buttonSize + this.spacer) );
            this.boundaryLine.attr( "path", pathStr );
            this.dragLine.attr( "path", pathStr );
            if( this.legendRange) {
                this.dragLine.node.setAttribute( 'aria-valuemin', this.legendRange.min );
                this.dragLine.node.setAttribute( 'aria-valuemax', this.legendRange.max );
                this.dragLine.node.setAttribute( 'aria-valuenow', this.legendRange.now );
            }
            // this.showHideBoundaryLine();

            this.closebox.data( "tooltip", Dyn.loc( "remove {{title}}", {
                title: (this.attribute ? this.attribute.name : Dyn.loc(Dyn.plotStrings.promptLegend))
            }));
            // update tooltips for current language
            //this.plusButton.data( "tooltip", Dyn.loc("increase number of bins"));
            //this.minusButton.data( "tooltip", Dyn.loc("decrease number of bins"));
            this.closebox.transform( "t" + closeXY.x + "," + closeXY.y );
            this.plusButton.transform( "t"+ plusXY.x +","+ plusXY.y );
            this.minusButton.transform( "t"+ minusXY.x +","+ minusXY.y );
            Dyn.axisUtil.updateAxisButton( this.plusButton );
            Dyn.axisUtil.updateAxisButton( this.minusButton );
            Dyn.plotUtil.showOrHideElement( this.plusButton, this.isUsingPlusMinus && !viewOnly );
            Dyn.plotUtil.showOrHideElement( this.minusButton, this.isUsingPlusMinus && !viewOnly );

            // position the color attribute title
            if( this.attribute ) {
                this.updateAttributeTitle( this.attribute, this.colorDropArea,
                    Dyn.loc('Color by {{attributename}}', {"attributename": this.attribute?.name }));
            } else if( this.isUsingPromptTitle ) {
                // if a prompt, update the title and closebox position
                let title = this.updatePromptTitle( this.colorDropArea,
                        Dyn.plotUtil.axisButtonSpacing + buttonSize,
                        Dyn.loc( Dyn.plotUtil.isTuvaJr() ? Dyn.plotStrings.promptJr : Dyn.plotStrings.promptLegend )),
                    promptBBox = title.getBBox(Dyn.plotUtil.textBBoxAfterTransform);
                this.closebox.transform( "t" + promptBBox.cx + "," + (promptBBox.y - Dyn.plotUtil.axisButtonSpacing - buttonSize/2) );
            } else {
                // Dyn.axisUtil.updateTextOrMathJax( this.colorDropArea, { text:'' } ); // hide the title
                this.colorDropArea.title.hide();
            }
            Dyn.plotUtil.showOrHideElement( this.closebox, (this.attribute || this.isUsingPromptTitle) && !viewOnly );

            // show/hide/position the color legend below the color attribute title
            this.updateColorLegend();

            let mode = new Dyn.PlotViewMode();
            if( !(mode.showControls() && mode.showAxes())) {
                this.setViewMode( mode ); // hide controls
            }
            this.needsVisualsUpdate = false;
        }

        // vertical line inset from left edge of right margin
        _verticalPathLine( x, y, height ) {
            return "M"+x+","+y+"L"+x+","+(y+height);
        }

        /**
         * Make right margin image ready or view only
         * @param mode ({Dyn.PlotViewMode}|{Dyn.PlotModeImageReady}) - new mode settings
         */
        setViewMode( mode ) {
            const showControls = mode.showControls(),
                showAxes = mode.showAxes();
            if( this.getAttribute() || this.isUsingPromptTitle ){
                Dyn.plotUtil.showOrHideElement( this.closebox, showControls );
                if( this.isUsingPromptTitle ) {
                    Dyn.plotUtil.showOrHideElement( this.dropRect, showControls );
                    Dyn.plotUtil.showOrHideElement( this.colorDropArea.title, showControls );
                }
                if( this.isUsingPlusMinus ) {
                    Dyn.plotUtil.showOrHideElement( this.plusButton, showControls );
                    Dyn.plotUtil.showOrHideElement( this.minusButton, showControls );
                }
            }
            if(showControls) {
                Dyn.plotUtil.showOrHideElement( this.dragLine, showAxes );
                Dyn.plotUtil.showOrHideElement( this.dropRect, showAxes );
                Dyn.plotUtil.showOrHideElement( this.dropRectOverlay, showAxes );
            }
        }

        /**
         * Calculate the desired Right Margin view thickness, so we can
         * determine if our plot view needs to be updated.
         * NOTE: does not actually update the plot view.
         * @returns {Dyn.MarginView.legendThickness|*} -- desired view width in pixels.
         */
        calcThickness() {
            const wantExpanded = this.colorDropArea.wantExpanded( this.attribute )
                    || this.bubbleDropArea.wantExpanded();
            let minThickness = Dyn.plotUtil.kMinAxisThickness,
                maxThickness = this.paper.width * Dyn.plotUtil.kLegendMaxProportion,
                newThickness = ( wantExpanded ?
                    this.legendThickness : // user-adjusted thickness if legend visible
                    Dyn.plotUtil.kMinAxisThickness ); // thickness if no legend (see #2139)
            if( Dyn.plotUtil.isDrawOnly() ) {
                // hide margin/legend if in draw-only mode
                newThickness = minThickness = maxThickness = 0;
            } else if( this.isUsingPromptTitle ) {
                // expand the legend thickness to accommodate the prompt title if needed
                const promptFontSize = Dyn.preferences.getFontSize( Dyn.plotUtil.kPlotTitleFontSize ),
                    buttonHeight = Dyn.plotUtil.getTouchAdjustedSize( Dyn.plotUtil.iconSize ),
                    textHeight = Dyn.plotUtil.getTextBBox( this.paper, "Xy", promptFontSize ).height,
                    promptXHeight = Dyn.plotUtil.kAxisTitleMargin + Math.max( textHeight, buttonHeight );
                minThickness = Math.max( minThickness, promptXHeight );
            }
            minThickness = Math.min( minThickness, maxThickness );
            maxThickness = Math.max( minThickness, maxThickness );
            newThickness = Dyn.mathUtil.clipToRange( newThickness, minThickness, maxThickness );
            this.legendRange = {
                min: 0, max: 100, // #2726 range for aria-valuenow, aria-valuemin, aria-valuemax is [0, 100]
                now: Math.round( 100 * (newThickness - minThickness) * Dyn.mathUtil.invertSafely(maxThickness - minThickness))
            };
            return newThickness;
        }

        /**
         * Get the attribute used in this view, or null if none.
         * @returns {Dyn.Attribute|null}
         */
        getAttribute() {
            return this.attribute;
        }

        // Get the height of the DropRect, based on this view's height
        getAdjustedHeight() {
            if( this.isColorAxis() ){
                // end drop zone at bottom of X axis, for increased coverage of long lists of categories
                return this.bounds.height;
            } else {
                // end drop zone at top of X axis
                return Math.max(0, this.bounds.height - (this.bounds.bottom() - Dyn.plotView.xAxis.dropRect.attr("y")));
            }
        }

        // TODO: remove and only use drop area versions, this.colorDropArea.getDropRectFillColor(), etc.
        getDropRectFillColor( dropState=null ) {
            let wantPromptColor = this.isUsingPromptTitle || ! this.attribute;
            return this.colorDropArea.getDropRectFillColor( this.isIncompleteAxis(), wantPromptColor, dropState );
        }

        // TODO: remove and only use drop area versions, this.colorDropArea.getDropRectFillOpacity(), etc.
        getDropRectFillOpacity( /* dropState */ ) {
            // Dyn.DropState.isValid( dropState );
            let hasValidAttribute = this.attribute,
                isPrompting = (this.isUsingPromptTitle && ! this.attribute),
                isDraggingAttribute = Boolean( this.draggedAttr );
            return this.colorDropArea.getDropRectFillOpacity( hasValidAttribute, isPrompting, isDraggingAttribute );
        }

        // TODO: remove and only use drop area versions, this.colorDropArea.getDropRectStrokeOpacity(), etc.
        getDropRectStrokeOpacity( /* dropState */) {
            // Dyn.DropState.isValid( dropState );
            if( this.draggedAttr || this.isUsingPromptTitle ) {
                // show stroke with prompt axis or droppable attribute over drop area
                return 1;
            } else {
                // hide stroke if axis in use, or empty, or this.isIncompleteAxis()
                return 0;
            }
        }

        dropAreas() {
            return[ this.colorDropArea, this.bubbleDropArea, this.orderDropArea ];
        }

        /**
         * Adjust the margin/legend/dropzone for the start of a drag
         * Compare to AxisView.highlightDropAreas(), and resetHighlightDropAreas()
         * @param draggedAttr
         */
        highlightDropAreas( draggedAttr, /*deltaThickness*/ ) {
            var isStartOfDrag = Boolean( draggedAttr ), // or !this.dropRect.data( "isDragExpanded" )
                isInDrag = Boolean( this.draggedAttr ),
                fillColor = this.getDropRectFillColor("isHighlight");

            if( Dyn.preferences.isViewOnly()) {
                // no dragging/highlighting allowed
                this.dropAreas().forEach(
                    area => area.dropRectOverlay.hide() );
            } else if( isStartOfDrag ) {
                this.draggedAttr = draggedAttr;
                let oldWidth = this.dropRect.attr( "width" ),
                    newWidth = Math.max( this.bounds.width, Dyn.plotUtil.dropExpandMin ),
                    deltaWidth = (newWidth-oldWidth),
                    newX = this.bounds.right() - newWidth,
                    orderDropRect = { x: newX, y: this.orderDropArea.bounds.y, width: newWidth,
                        height: this.orderDropArea.bounds.height },
                    bubbleDropRect = { x: newX, y: this.bubbleDropArea.bounds.y, width: newWidth,
                        height: this.bubbleDropArea.bounds.height },
                    colorDropRect = { x: newX, y: this.colorDropArea.bounds.y, width: newWidth,
                        height: this.colorDropArea.bounds.height };

                this.boundaryLine.hide();
                this.dragLine.hide();

                // color and expand drop area
                this.orderDropArea.highlightDropAreas( orderDropRect, fillColor );
                this.bubbleDropArea.highlightDropAreas( bubbleDropRect, fillColor );
                this.colorDropArea.highlightDropAreas( colorDropRect, fillColor );

                // shift title and associated closebox to center of drop zone
                if( this.isUsingPromptTitle ) {
                    let colorTitle = this.colorDropArea.title,
                        bbox = colorTitle.getBBox(Dyn.plotUtil.textBBoxAfterTransform);
                    Dyn.axisUtil.shiftTitle( colorTitle, bbox, -deltaWidth / 2, 0, true );
                    Dyn.axisUtil.shiftButton( this.closebox, -deltaWidth / 2, 0 );
                }
                this.dropRect.data( "isDragExpanded", true );
            } else if ( isInDrag ) {
                this.dropAreas().forEach(
                    area => area.dropRect.attr({ fill: fillColor }));
            }
        }

        resetHighlightDropAreas() {
            if( this.draggedAttr ) {
                // undo highlightDropAreas() customizations
                this.draggedAttr = null;
                this.dropRectOverlay.hide();
                this.removeGlow();
                this.updateVisuals();
            }
            this.dropRect.data( "isDragExpanded", false );
        }

        // To handle the dropped attribute
        mouseUpHandler( dropArea ) {
            this.removeGlow();
            if( this.draggedAttr ) switch( dropArea.axisID ) {
                case "color":
                    mediator.publish( "records:attributeNameSelected", {
                        id: this.draggedAttr.id
                    } );
                    break;
                case "order":
                    mediator.publish( "records:newOrderByAttribute", {
                        id: this.draggedAttr.id
                    } );
                    break;
                case "bubble":
                    mediator.publish( "records:newBubbleByAttribute", {
                        id: this.draggedAttr.id
                    } );
                    break;
            }
        }

        mouseOverDroppableAreas( dropArea ) {
            let dropRect = dropArea.dropRect;
            if( this.draggedAttr ) {
                this.addGlow( dropRect );
                dropRect.attr( { fill: Dyn.plotUtil.overDropFillColor } );
            }
        }

        // To reset the mouse over style when attribute is in drag mode
        mouseOutDroppableAreas( dropArea ) {
            this.removeGlow();
            this.highlightDropAreas(); // undo mouseOverDroppableAreas() styling
        }

        isPointInDropRect( xPosition, yPosition ){
            let bodyRect = document.body.getBoundingClientRect(),
                elemRect = this.paper.canvas.getBoundingClientRect(),
                offsetY = elemRect.top - bodyRect.top,
                offsetX = elemRect.left - bodyRect.left,
                isPointInRect = false;
            if( this.dropRect ) {
                let bbox = this.dropRect._getBBox(),
                    rect = (new Dyn.mathUtil.Rect( bbox )).offset( offsetX, offsetY );
                isPointInRect = rect.isPointInRect( xPosition, yPosition );
            }
            return { inDropRect:isPointInRect };
        }

        addGlow( elementToGlow ) {
            "use strict";
            var width = Dyn.plotUtil.dropGlowWidth,
                glowColor = elementToGlow.attr("stroke");
            this.removeGlow(); // remove previous glow, if any
            this.glowElement = elementToGlow.glow( {
                color: glowColor,
                width: width
            });
        }

        /**
         * Remove the glow element created by addGlow()
         */
        removeGlow() {
            "use strict";
            if( this.glowElement ) {
                this.glowElement.remove();
                this.glowElement = null;
            }
        }

        // To reset to default view
        reset() {
            this.setSelectedAttributeLegend( null );
            this.legendThickness = Dyn.plotUtil.kLegendStdThickness;
            this.isUsingPromptTitle = ! Dyn.plotUtil.isDrawOnly();
            this.isIncompleteAxisStyle = false;
            this.isDisabledAttribute = false;
        }

        /** @returns {boolean} -- true if axis empty/blank (no prompt or attribute) */
        isNullAxis() {
            return ! (this.attribute || this.isUsingPromptTitle);
        }

        /** @returns {boolean} -- true if axis has prompt (non-attribute title) */
        isPromptAxis() {
            return ( ! this.attribute && this.isUsingPromptTitle );
        }

        /** @returns {boolean} -- true if we have a non-disabled attribute to color by. */
        isColorAxis() {
            return Boolean( this.attribute && ! this.isDisabledAttribute ); // we have an attribute to color by
        }

        getColorAttribute() {
            return( this.isColorAxis() ? this.attribute : null );
        }

        isIncompleteAxis() {
            // return true if we have prompt in the "incomplete plot" style
            // see also .setIncompleteAxis()
            return Boolean(this.isIncompleteAxisStyle /*&& this.isUsingPromptTitle && ( ! this.attribute )*/ );
        }

        setIncompleteAxis( wantIncompleteAxisStyle ) {
            //let wasShowingIncompleteAxisStyle = this.isIncompleteAxis();
            // allow style to be on only if prompt axis, no legend attribute
            this.isIncompleteAxisStyle = Boolean(wantIncompleteAxisStyle && ! this.attribute);
            if( this.isIncompleteAxisStyle ) {
                this.isUsingPromptTitle = true; // also show prompt
                Dyn.assert( ! this.attribute ); // conditions for this.isIncompleteAxis()
            }
            // if( this.isIncompleteAxisStyle !== wasShowingIncompleteAxisStyle ) {
            //     // refresh legend if turned on or off
            //     this.updateVisuals();
            // }
        }

        /**
         * Set the attribute used for the legend, and update the legend display.
         * @param attribute
         */
        setSelectedAttributeLegend( attribute ) {
            if( attribute ) {
                this.attribute = attribute;
            } else {
                this.attribute = null;
            }
            this.updateVisuals();
        }

        /** Update the Attribute Legend, to be done when ever the attribute changes, is cleared, or has data/filter changes */
        updateColorLegend() {
            // remove the old legend display if any
            if( this.attributeLegend ) {
                Dyn.plotUtil.removeElementAndToolTip( this.attributeLegend );
                this.attributeLegend = null;
            }

            // add the new legend display if any
            let attribute = this.attribute;
            if( attribute ) {
                let viewOnly = Dyn.preferences.isViewOnly(),
                    x0 = this.bounds.x,
                    y0 = this.colorDropArea.bounds.y,
                    y1 = y0 + (this.spacer*2) + this.colorDropArea.titleBBox.height,
                    y2 = y0 + this.colorDropArea.bounds.height,
                    x1 = x0 + this.spacer*2,
                    x2 = x0 + this.bounds.width - this.spacer,
                    ariaLabel = Dyn.stringFormat(Dyn.plotUtil.legendCloseButtonAriaLabel, attribute.name);
                // let legendBounds = new Dyn.mathUtil.Rect( x1, y1, x2-x1, y2-y1 );
                this.attributeLegend = this.paper.set();

                // Numeric Color Gradient or Categorical Color Squares
                attribute.updateStatsIfDataChange(); // Update the stats for Attribute
                let isUsingNumericIntervals = this.isUsingNumericIntervals && attribute.hasNumericIntervals(),
                    attributeLabels;
                if (attribute.stats.isNumeric() && !isUsingNumericIntervals) {
                    attributeLabels = this.makeNumericGradient(attribute, x1, y1, x2, y2, isUsingNumericIntervals);
                } else {
                    attributeLabels = this.makeCategoricalGradient(attribute, x1, y1, x2, y2, isUsingNumericIntervals);
                }
                this.attributeLegend.push( attributeLabels );

                this.boundaryLine.show();
                this.dragLine.show();
                // Dyn.plotUtil.showOrHideElement( this.closebox, !viewOnly );
                this.closebox[0].node.setAttribute( "aria-label", ariaLabel );
                // Dyn.plotUtil.showOrHideElement( this.plusButton, this.isUsingPlusMinus && !viewOnly );
                // Dyn.plotUtil.showOrHideElement( this.minusButton, this.isUsingPlusMinus && !viewOnly );

                this.isUsingPromptTitle = false;
                this.resetHighlightDropAreas();
            } else {
                // no selected attribute, clear the color legend
                // Dyn.plotUtil.hideElementAndToolTip( this.colorDropArea.title );
                this.showHideBoundaryLine();
                // this.dragLine.hide();
                // this.closebox.hide();
                // this.plusButton.hide();
                // this.minusButton.hide();
                this.scrollbar.hide();
                this.gradientOverlay.hide();
                this.marqueeSelectRect.hide();
            }
            this.needsLegendUpdate = false; // now up to date
        }


        /**
         * Create a title for the prompt
         */
        updatePromptTitle( baseObject, buttonWidth, titleString ) {
            Dyn.assert( [this.colorDropArea, this.orderDropArea, this.bubbleDropArea].includes( baseObject ));
            const bbox = baseObject.bounds,
                titleFontSize = Dyn.preferences.getFontSize( Dyn.plotUtil.kPlotTitleFontSize ),
                textStyle = {
                    text: titleString,
                    x: bbox.centerX(),
                    y: bbox.centerY() + buttonWidth/2,
                    "font-size": titleFontSize,
                    "font-family": Dyn.plotUtil.kAxisFontFamily,
                    "text-anchor": "middle",
                    'fill': Dyn.plotUtil.titleColor,
                    "class": (this.isIncompleteAxis() ? 'tde-attribute-name tde-alert' : 'tde-attribute-name')
                        + " " + Dyn.plotUtil.hideOnPreviewClass,
                };

            // vertical text centered, for a narrow drop rect
            if( baseObject.title?.data("isPrompt")===false ) { // if existing title created by updateAttributeTitle()
                Dyn.axisUtil.initTextOrMathJaxElement( baseObject, this.paper ); // re-initialize to remove different titleAttrs
            }
            let title = Dyn.axisUtil.updateTextOrMathJax( baseObject, textStyle ); // replace previous mathJax attribute name, if any
            title.attr( "transform", "r-90" ); // rotate last to work around bug #21 (rotated text disappears randomly)?
            title.data("isPrompt",true);
            Dyn.plotUtil.clipStringToWidth( title, Math.max(0, bbox.height - buttonWidth ));
            title.show();
            return title;

            // wrapped horizontal text paragraph, for a wide drop rect
            // const lineHeight = titleFontSize * 1.35; // 135%, ref: https://practicaltypography.com/line-spacing.html;
            // return this.paper.paragraph( {
            //     x: Math.round( bbox.x + bbox.width / 2 ),
            //     y: Math.round( bbox.y + bbox.height / 2 - 2 * lineHeight ),
            //     maxWidth: 45,
            //     lineHeight: lineHeight,
            //     text: Dyn.loc( Dyn.plotUtil.isTuvaJr() ? Dyn.plotStrings.promptJr : Dyn.plotStrings.promptLegend ),
            //     textStyle: textStyle
            // } );
        }

        /**
         * show the attribute name as a title on center-top of color or bubble legend
         * @param attribute {Dyn.Attribute}
         * @param baseObject this.colorDropArea or this.bubbleDropArea, that holds .title, .titleAttrs, .svgCache
         * @returns {*}
         */
        updateAttributeTitle( attribute, baseObject, tooltipText ) {
            // show the attribute name as a title on center-top of color or bubble legend
            let titleStr = Dyn.plotUtil.unescapeText( attribute.name ),
                titleX = baseObject.bounds.centerX() + this.spacer * 2,
                titleXMathJax = baseObject.bounds.x + ( 3 + this.spacer * 3 ), // left justify (but needs more space for some reason)
                titleY = baseObject.bounds.y,
                titleWidth = Math.max(0, baseObject.bounds.width - this.spacer * 3),
                titleAttrs = {
                    text: titleStr,
                    x: titleX,
                    y: titleY,
                    'font-size': Dyn.preferences.getFontSize( this.legendFontSize ),
                    "font-weight": "bold",
                    'fill': Dyn.plotUtil.titleColor,
                    "class": 'tde-attribute-name' + (this.isUsingPromptTitle ? ' ' + Dyn.plotUtil.hideOnPreviewClass : '') + (this.isDisabledAttribute ? ' tde-disabled' : '')
                },
                wantMathJaxStr = hasMathJaxPattern( titleStr ),
                rightMargin = this;

            // Uggh, we are always creating a text title in order to get a valid bbox
            if( baseObject.title?.data("isPrompt")===true ) { // if existing title created by updatePromptTitle()
                Dyn.axisUtil.initTextOrMathJaxElement( baseObject, this.paper ); // re-initialize to remove different titleAttrs
            }
            let attributeTitle = Dyn.axisUtil.updateTextOrMathJax( baseObject, titleAttrs );
            // Dyn.plotUtil.clipStringToWidth( attributeTitle, titleWidth );
            // attributeTitle.attr({"transform": Dyn.plotUtil.getTextTransform( attributeTitle, "center,top" )});

            // replace text with MathJax if needed
            attributeTitle = Dyn.axisUtil.updateTextOrMathJax( baseObject, titleAttrs, wantMathJaxStr, setSvgTitle.bind( baseObject ));
            if( ! wantMathJaxStr ) {
                // clip the title to fit in the titleBounds
                Dyn.plotUtil.clipStringToWidth( attributeTitle, titleWidth );
                attributeTitle.attr( { "transform": Dyn.plotUtil.getTextTransform( attributeTitle, "center,top" ) } );
            }

            function setSvgTitle( _svg ) {
                Dyn.assert( this === rightMargin.colorDropArea || this === rightMargin.bubbleDropArea );
                Dyn.assert( this.title && this.titleAttrs && this.titleAttrs['font-size'] );
                if( !attributeTitle.node ) {
                    return;
                }
                this.svgCache = {
                    attrname: attribute.name,
                    svg: _svg
                }
                // Style svg
                _svg.style.fontSize = this.titleAttrs['font-size'] - 2;
                _svg.style.fontWeight = "bold";
                _svg.style.color = Dyn.plotUtil.titleColor;
                // _svg.class = 'tde-attribute-name' + (this.isDisabledAttribute? ' tde-disabled': '')
                // Append the svg into the title node
                attributeTitle.node.appendChild( _svg );
                // To position it in center of the give x and y position
                let cx = Math.round( titleXMathJax ),
                    cy = Math.round( titleY ),
                    bbox = attributeTitle.type === 'g'
                            ? Dyn.axisUtil.getBBoxForG( attributeTitle )
                            : attributeTitle.getBBox();
                Dyn.assertValidRect( bbox );
                attributeTitle.attr( {
                    transform: 'r0T' + cx + ',' + cy,
                    x: cx, y: cy,
                    width: bbox.width, height: bbox.height,
                    "class": 'tde-attribute-name' + (this.isDisabledAttribute ? ' tde-disabled' : '')
                } );
                attributeTitle.node.style.pointerEvents = "bounding-box";
            }

            // Adding tooltip and hover events
            Dyn.assert( baseObject.title ); // assigned by updateTextOrMathJax()
            attributeTitle.data( { "tooltip": tooltipText } );
            attributeTitle.data( { "isPrompt": false } );
            attributeTitle.hover( this.hoverStart, this.hoverEnd );
            attributeTitle.show();
            return attributeTitle;
        }

        /**
         * @param attribute {Dyn.Attribute}
         * @param x1
         * @param y1
         * @param x2
         * @param y2
         * @param isUsingNumericIntervals
         * @returns {*} - paper.set()
         */
        makeNumericGradient( attribute, x1, y1, x2, y2, isUsingNumericIntervals ) {
            var info = this.getCategoryInfo( attribute, isUsingNumericIntervals, Dyn.preferences.getFontSize( this.legendFontSize )),
                missingValueHeight = info.hasMissingValueCategory ? info.lineHeight : 0,
                largeGradientMargin = ((y2-y1 > 500) ? Dyn.plotUtil.dropExpandMin : 0 ), // don't go below x-axis if lots of space
                gradientWidth = Dyn.plotUtil.kGradientThickness,
                gradientX = x1 + Math.round( Math.max( this.spacer /*right justify*/, (x2-x1)*0.1 )),
                gradientY = y1,
                gradientHeight = Math.max(0, y2-y1 - this.spacer * 2 - missingValueHeight - largeGradientMargin),
                gradientRect = new Dyn.mathUtil.Rect( gradientX, gradientY, gradientWidth, gradientHeight ),
                tickX = gradientX + gradientWidth,
                tickX2 = tickX + this.legendNumericTickLength,
                tickXM2 = tickX + this.legendMinorTickLength,
                textX = tickX2 + this.legendNumericTickToTextSpace,
                attributeLabels,
                paper = this.paper,
                marginView = this;

            attributeLabels = this.paper.set();
            this.scrollbar.hide();
            if( this.isDisabledAttribute ) {
                // don't draw full numeric gradient, instead show grayedGradientRect
                let grayedGradientRect = this.paper.rect( gradientRect.x, gradientRect.y, gradientRect.width, gradientRect.height )
                    .attr( { fill: Dyn.plotUtil.kCaseMissingAxisColor, stroke:'none' });
                attributeLabels.push( grayedGradientRect );
                this.gradientOverlay.hide();
                this.marqueeSelectRect.hide();
                return attributeLabels;
            }

            // calc gradient and axis options
            let axisRange = new Dyn.mathUtil.Range( attribute.stats.min, attribute.stats.max ),
                axisOptions = {
                    subType: attribute.subType, // for special handling of date/time numeric types
                    formatString: attribute?.format?.formatString, // or fractions;
                    exactWidth: attribute?.format?.axisMajorWidth, // optional major interval width from MetaData
                    minorWidth: attribute?.format?.axisMinorWidth, // optional minor interval width from MetaData
                },
                targetNumTicks = Math.max( this.minNumTicks, Math.round( gradientHeight / this.pixelsPerTick )),
                isFraction = attribute.subType === Dyn.dataUtil.subtypes.kFraction;
            if( isFraction ) {
                targetNumTicks = Dyn.fractionData.approxNumTicksOnAxis;
                // fractions have tick marks 'outside' of data, to match axis tick marks
                axisOptions[Dyn.dataUtil.EIntervalRange.irLowerOutside] = true;
                axisOptions[Dyn.dataUtil.EIntervalRange.irUpperOutside] = true;
                axisOptions.maxDecimals = attribute.getNumericDecimals(); // restrict major tick marks to user preference
                axisOptions.maxDataDecimals = attribute.getNumericDecimals( undefined, true ); // restrict minor tick marks to data decimals
            } // else  Dyn.dataUtil.EIntervalRange.irLowerInside, irUpperInside
            axisRange.makeNonZeroWidth( 0.1 *(attribute.statsPreFilter.max - attribute.statsPreFilter.min));

            // make gradient
            let niceIntervals = Dyn.dataUtil.calcNiceIntervals( axisRange.min, axisRange.max, targetNumTicks, axisOptions ),
                coordMap = new Dyn.mathUtil.CoordMap( gradientY, gradientY+gradientHeight,
                    (attribute.isSortAscending ? axisRange.max : axisRange.min),
                    (attribute.isSortAscending ? axisRange.min : axisRange.max)),
                gradientSet;
            if( isFraction ) {
                // put data gradient inside extended axis ticks to go to next tick mark
                coordMap = new Dyn.mathUtil.CoordMap( gradientY, gradientY+gradientHeight,
                    (attribute.isSortAscending ? niceIntervals.max : niceIntervals.min),
                    (attribute.isSortAscending ? niceIntervals.min : niceIntervals.max));
                let yMinMax = [ axisRange.min, axisRange.max ].map( n => Math.round(coordMap.transform(n)))
                        .sort((a,b) => (a-b)), // y at location of min and max tickmarks, sorted in case data order is reversed
                    innerRect = new Dyn.mathUtil.Rect(
                        gradientRect.x, yMinMax[0], gradientRect.width, Math.max( 0, yMinMax[1] - yMinMax[0]) );
                gradientSet = Dyn.colorUtil.makeGradientSet( this.paper, innerRect, attribute,
                    false /* vertical */, false /* post-filter */, axisRange, gradientRect );
            } else {
                gradientSet = Dyn.colorUtil.makeGradientSet( this.paper, gradientRect, attribute,
                    false /* vertical */, false /* post-filter */, axisRange );
            }
            attributeLabels.push( gradientSet );

            // make labels
            let decimalPrecision = axisOptions.subType ? undefined : Dyn.mathUtil.decimalPlaces( niceIntervals.intervalWidth ),
                altFormatString = ( axisOptions.subType !== Dyn.dataUtil.subtypes.kFraction) ? undefined :
                    Dyn.fractionData.getAxisFormat( attribute.format.formatString, attribute.format.axisFormat, niceIntervals.intervalWidth ),
                majorMinor = Dyn.dataUtil.calcMinorTickData( coordMap, niceIntervals.niceWidthOptions, niceIntervals.intervalWidth, niceIntervals.isExactWidth ),
                pixMinMax = (new Dyn.mathUtil.Range( gradientY, gradientY+gradientHeight+1 )).normalize();
            this.dragData.coordMap = coordMap;
            niceIntervals.values.forEach( dataVal => {
                let tickY = coordMap.transform( dataVal );
                if( pixMinMax.isInRange( tickY ) ) { // caution: niceIntervals calc may have one too many tickmarks
                    let textWidth = x2 - textX,
                        valueString = attribute.valueToString( dataVal, decimalPrecision, altFormatString ),
                        tickLine = paper.path( "M" + tickX + "," + tickY + "L" + tickX2 + "," + tickY ).attr( { stroke: Dyn.plotUtil.kAxisLineColor } ),
                        textElem = paper.text( textX, tickY, valueString );
                    if( this.showMinorTickMarks && majorMinor.hasMinor ) {
                        for( let m = 1; m < majorMinor.howMany; m++ ) { // ignore 0th tickmark which overlaps major
                            let tickYMinor = coordMap.transform( dataVal + (m * majorMinor.minorIntervalWidth) );
                            if( pixMinMax.isInRange( tickYMinor ) ) {
                                attributeLabels.push(
                                    paper.path( "M" + tickX + "," + tickYMinor + "L" + tickXM2 + "," + tickYMinor )
                                        .attr( { stroke: Dyn.plotUtil.kAxisLineColor } ) );
                            }
                        }
                    }
                    textElem.data( "tooltip", valueString ); // full text as tool tip in case tick label is clipped
                    textElem.hover( marginView.hoverStart, marginView.hoverEnd );
                    textElem.attr( {
                        "font-size": Dyn.preferences.getFontSize( this.legendFontSize ),
                        "text-anchor": "start",
                        'fill': Dyn.plotUtil.titleColor,
                        "class": 'tde-category-name'
                    } );
                    Dyn.plotUtil.clipStringToWidth( textElem, textWidth );
                    attributeLabels.push( tickLine, textElem );
                }
            });

            // missing value square
            if( info.hasMissingValueCategory ) {
                // category is {missing}
                info.catString = Dyn.dataUtil.kMissingValue; // normally a string, but use "null" since that is the actual data value
                info.displayString = Dyn.loc( Dyn.dataUtil.kMissingValueName );
                info.caseColor = new Dyn.colorUtil.SVG_Color( Dyn.plotUtil.kCaseMissingValueColor );
                // position at bottom of legend
                info.colorSquareX = gradientX;
                info.textX = info.colorSquareX + this.legendColorSquare + this.spacer;
                info.lineY = y2 - info.lineHeight;
                info.textWidth = x2 - info.textX;
                attributeLabels.push( this.createCategorySquareAndText( attribute, info, new Dyn.DragCategoryUtil(this) ) );
            }

            // numeric selection drag rect and visible indicator
            this.gradientOverlay.attr({ x:gradientRect.x, y:gradientRect.y, width:gradientRect.width, height:gradientRect.height })
                .show().toFront();
            let dataRange = Dyn.dataSet.getSelectedByNumericRange();
            if( dataRange ) {
                this.dragData.dataRange = new Dyn.mathUtil.Range( dataRange );
                let y1 = coordMap.transform( this.dragData.dataRange.min ),
                    y2 = coordMap.transform( this.dragData.dataRange.max );
                this.showMarqueeSelectRect( y1, y2 );
            } else {
                this.marqueeSelectRect.hide();
            }

            return attributeLabels;
        }

        /**
         * @param attribute {Dyn.Attribute}
         * @param x1
         * @param y1
         * @param x2
         * @param y2
         * @param isUsingNumericIntervals
         * @returns {*} - paper.set()
         */
        makeCategoricalGradient( attribute, x1, y1, x2, y2, isUsingNumericIntervals ) {
            "use strict";
            var info = this.getCategoryInfo( attribute, isUsingNumericIntervals ),
                attributeLabels = this.paper.set(),
                categories = info.categories,
                numCategories = info.numCategories;

            info.clipRectString = ''+x1+','+y1+','+(x2-x1)+','+(y2-y1);
            info.colorSquareX = x1;
            info.textX = x1 + this.legendColorSquare + this.spacer;
            info.lineY = y1;
            info.textWidth = x2 - info.textX;
            this.scrollbar.
                setViewRect( x1, y1, x2, y2 ).
                setWindowSize( info.lineHeight * numCategories, info.lineHeight ).
                updateView();
            info.textWidth -= this.scrollbar.getBarThickness();
            info.lineY -= this.scrollbar.getScrollOffset();
            this.gradientOverlay.hide(); // not used by categorical gradients
            this.marqueeSelectRect.hide(); // not used by categorical gradients
            let dragInfo = new Dyn.DragCategoryUtil( this, info.lineY, info.lineHeight, info.numDraggableCategories, attribute );

            // make color squares and labels for each category
            for( let i=0; i<numCategories; ++i ) {

                if( (info.lineY >= (y1 - info.lineHeight) ) && ( info.lineY < y2 )) { // in scroll area?
                    info.catIndex = i;
                    info.catString = categories[i];
                    info.displayString = (i<categories.length) ? attribute.categoryValueToString( info.catString ):"";
                    if( ! info.displayString ) {
                        info.catString = Dyn.dataUtil.kMissingValue; // null
                        info.displayString = Dyn.loc( Dyn.dataUtil.kMissingValueName ); // "{missing}"
                        info.caseColor = new Dyn.colorUtil.SVG_Color( Dyn.plotUtil.kCaseMissingValueColor);
                    } else if ( isUsingNumericIntervals ) {
                        info.caseColor = Dyn.colorUtil.calcContinuousColor(
                            attribute.statsPreFilter,
                            attribute.color,
                            attribute.numericIntervalIndexToValue( i ),
                            false );
                    } else {
                        info.caseColor = Dyn.colorUtil.calcCategoryColor(
                            attribute.statsPreFilter,
                            attribute.color,
                            info.catString,
                            false,
                            attribute.colorMap,
                            attribute.isSortAscending );
                    }
                    attributeLabels.push( this.createCategorySquareAndText( attribute, info, dragInfo ) );
                }

                info.lineY += info.lineHeight;
            }

            if( this.isDisabledAttribute ) {
                this.scrollbar.hide();
            } else {
                this.scrollbar.toFront(); // move scrollbar to top of newly-created elements (which default to front of paper when created)
            }
            return attributeLabels;
        }

        /**
         * Collect some information for creating a category gradient or single missing value color square.
         * @param attribute
         * @param isUsingNumericIntervals
         * @param optionalFontSize
         * @returns {{}}
         */
        getCategoryInfo( attribute, isUsingNumericIntervals, optionalFontSize ) {
            function getCategoryFontSize( numCategories ) {
                let stdSize = 12;
                if( numCategories <= 4 ) {
                    stdSize = 18;
                } else if( numCategories <= 8 ) {
                    stdSize = 16;
                } else if( numCategories <= 16 ) {
                    stdSize = 14;
                }
                return Dyn.preferences.getFontSize( stdSize );
            }

            var info = { };
            info.hasMissingValueCategory = ( attribute.stats.missingCaseCount > 0 );
            info.categories = ( isUsingNumericIntervals ? attribute.numericIntervals.categories : attribute.stats.categories);
            info.numCategories = info.categories.length + (info.hasMissingValueCategory ? 1 : 0);
            info.fontSize = optionalFontSize ? optionalFontSize : getCategoryFontSize( info.numCategories );
            info.lineHeight = Dyn.plotUtil.getTextBBox( this.paper, "X", info.fontSize ).height * Dyn.plotUtil.kLegendCategoryHeight;
            info.numDraggableCategories = info.categories.length; // exclude missing value category
            return info;
        }

        /**
         * Create a single line of the category legend, or the missing value line of the numeric legend
         * @param attribute
         * @param info -- all of the positioning and coloring information we require
         * @returns {*} --Raphael set with color square and category text label
         */
        createCategorySquareAndText( attribute, info, dragInfo ) {
            "use strict";
            // let opacity = Dyn.dataSet.isDeselectedCategory( info.catString ) ? Dyn.plotUtil.kDeselectedCategoryOpacity : 1,
            let set = this.paper.set(),
                isSelected = Dyn.dataSet.isCategorySelected( info.catString );

            // category text
            let textElem = this.paper.text( info.textX, info.lineY, info.displayString );
            textElem.attr( {
                "font-size": info.fontSize,
                // opacity: opacity,
                'clip-rect': info.clipRectString
            });
            if( ! this.isDisabledAttribute ) {
                textElem
                    .drag( this.dragMoveCategory, this.startDragCategory, this.endDragCategory )
                    //.click(this.clickCategory)
                    .hover(this.hoverStart, this.hoverEnd) // show tooltip on hover
                    .data("attributeID", attribute.id)
                    .data("category", info.catString)
                    .data("displayString", info.displayString )
                    .data("isNumericInterval", Boolean(this.isUsingNumericIntervals))
                    .data("tooltip", info.displayString)
                    .data("catIndex", info.catIndex )
                    .data("dragInfo", dragInfo ); // shared drag info object
            }
            Dyn.plotUtil.clipStringToWidth( textElem, info.textWidth );
            textElem.attr( {
                transform: Dyn.plotUtil.getTextTransform( textElem, "left,top" ),
                fill: Dyn.plotUtil[ isSelected ? 'titleColorInverse' : 'titleColor' ],
                class: 'tde-category-name' + (this.isDisabledAttribute? ' tde-disabled': '')
            });
            // set.push( textElem );

            // category color square
            let textBBox = textElem.getBBox(),
                squareVOffset = ( textBBox.height / 2 - this.legendColorSquare / 2 ),
                colorRect = new Dyn.mathUtil.Rect( info.colorSquareX, info.lineY + squareVOffset, this.legendColorSquare, this.legendColorSquare ),
                colorSquare = this.paper.rect( colorRect.x, colorRect.y, colorRect.width, colorRect.height );
            dragInfo.squareVOffset = squareVOffset; // for dragMoveCategory
            this._calcBorderColor( info );
            colorSquare.attr(
                this.isDisabledAttribute
                    ? { fill: 'none', stroke: Dyn.plotUtil.kCaseMissingAxisColor }
                    : { fill: info.fillColor, stroke: info.borderColor } );
            if( ! this.isDisabledAttribute ){
                colorSquare
                    .drag( this.dragMoveCategory, this.startDragCategory, this.endDragCategory )
                    //.click(this.clickCategory)
                    .hover(this.hoverStart, this.hoverEnd) // show tooltip on hover
                    .data("attributeID", attribute.id)
                    .data("category", info.catString)
                    .data("displayString", info.displayString )
                    .data("isNumericInterval", Boolean(this.isUsingNumericIntervals))
                    .data("tooltip", info.displayString)
                    .data("catIndex", info.catIndex )
                    .data("dragInfo", dragInfo ); // shared drag info object
            }
            if (info.clipRectString) {
                colorSquare.attr('clip-rect', info.clipRectString);
            }
            // set.push(colorSquare);

            // highlight selected categories with a background with inverse colors
            if( isSelected ) {
                let br = new Dyn.mathUtil.Rect( textBBox.x, textBBox.y, textBBox.width, info.lineHeight )
                        .union( colorRect ).expand( 3, 0 ).offset( 0, -1 ),
                    backgroundEl = this.paper.rect( br.x, br.y, br.width, br.height )
                        .attr({ fill: Dyn.plotUtil.titleSelectedColor })
                        .data("selected", true );
                set.push( backgroundEl );
                dragInfo.backgroundVOffset = br.y - textBBox.y; // for dragMoveCategory
                console.log( textBBox, colorRect, br, dragInfo.squareVOffset, dragInfo.backgroundVOffset );
            }
            set.push( textElem, colorSquare );

            return set;
        }

        _calcBorderColor( info ) {
            Dyn.colorUtil.calcColorBrightness( info.caseColor );
            let contrast255 = Math.abs(info.caseColor.b255 - Dyn.plotUtil.caseBackgroundBrightness);
            info.borderColor = ( contrast255 >= Dyn.plotUtil.caseBackgroundMinContrast )
                ? info.caseColor.colorString
                : Dyn.plotUtil.kCaseSubtleBorder;
            info.fillColor = info.caseColor.colorString;
        }

        /**
         * setup tooltip and any other relevant action
         */
        hoverStart( event ){
            "use strict";
            var isCategory = Boolean(this.data("category")),
                displayString = this.data("displayString"),
                isMissingElement = false;

            if (displayString === Dyn.loc(Dyn.dataUtil.kMissingValueName)){
                isMissingElement = true;
            }
            Dyn.toolTip.show( this, event, { x:this.getBBox().x, y:this.getBBox().y2, alignRight: true });
            if( isCategory || isMissingElement) {
                event.currentTarget.style.cursor = Dyn.plotUtil.cursorPointer;
            }
        }

        /**
         * Clean up the tooltip
         */
        hoverEnd( event ) {
            "use strict";
            if( Dyn.toolTip.isMyElement( this )) {
                Dyn.toolTip.hide();
            }
            event.currentTarget.style.cursor = Dyn.plotUtil.cursorDefault;
            //console.log("margin hoverEnd");
        }

        /**
         * Position and show the marquee-select rectangle with a consistent margin for visibility.
         * When not in use, we just use .hide()
         */
        showMarqueeSelectRect( y1, y2, isDragging=false ) {
            let m = RightMarginView.marqueeMargin,
                minX = this.gradientOverlay.attrs.x - m,
                width = this.gradientOverlay.attrs.width + 2*m,
                minY = this.gradientOverlay.attrs.y - 2*m,
                height = this.gradientOverlay.attrs.height + 4*m,
                a = {
                    x: minX,
                    y: Math.min(y1,y2) - m,
                    width: width,
                    height: Math.abs(y1-y2) + m + m,
                    'clip-rect': '' + minX.toFixed( 0 ) + ',' + minY.toFixed( 0 ) + ','
                        + width.toFixed( 0 ) + ',' + height.toFixed( 0 )
                };
            Dyn.assertValidRect( a );
            this.marqueeSelectRect.attr(a).show().toFront();
        }

        /** handler for clicking on Attribute Category */
        clickCategory( event ) {
            "use strict";
            var attrID = this.data("attributeID" ),
                categoryName = this.data("category" ),
                wantAdd = Boolean( event && (event.shiftKey || event.ctrlKey || event.metaKey) ),
                isNumericInterval = this.data("isNumericInterval" ),
                data = { "attributeID":attrID, "category":categoryName, addToSelection:wantAdd, isNumericInterval:isNumericInterval };
            // play the data value for this category (e.g. pie slice width as value for category 'red'
            if( categoryName ) {
                let plotView = Dyn.plotView;
                Dyn.sound.playOneCategoryValue( plotView, attrID, categoryName, isNumericInterval );
            }
            // select the cases with the given category for this attribute
            mediator.publish( "records:casesSelectedByCategory", data );
        }

        /** handler to drag one category (text or color square) in legend. */
        startDragCategory( x, y, event ) {
            // drag event callback, this===dragged element created by createCategorySquareAndText()
            let dragInfo = this.data('dragInfo'),
                isNonMissingValue = ! Dyn.dataUtil.isMissing( this.data("category"));
            if( dragInfo.isDraggable && // must be draggable categories (e.g. not intervals)
                isNonMissingValue ) { // must not be {missing} category with null string
                this.data('inDrag', true );
                this.data('y0', this.attr('y'));
                // change cursor while mouse down (then revert to pointer cursor)
                this.attr('cursor', Dyn.plotUtil.cursorVerticalBothSide );
            }
            Dyn.plotUtil.safeStopPropogation( event );
        }

        endDragCategory( event ) {
            // drag event callback, this===dragged element created by createCategorySquareAndText()
            let dragInfo = this.data('dragInfo');
            if( this.data('inDrag') ) {
                let oldY = this.data( 'y0' ),
                    newY = this.attr( 'y' ),
                    catIndex = this.data('catIndex'),
                    newIndex = this.data('newIndex'),
                    attributeID = this.data( 'attributeID' );
                if( dragInfo.isClickNotDrag( oldY, newY )) {
                    // no dragging took place on mouse up; treat as a click to select the category
                    dragInfo.view.clickCategory.call( this, event );
                }
                if( newIndex >= 0 && newIndex !== catIndex ) {
                    // animate to final position
                    dragInfo.view.moveCategoriesToDragPosition( oldY, catIndex, newIndex, dragInfo, true );
                    // save changes and update all views
                    setTimeout( ()=> {
                        Dyn.assert(attributeID);
                        mediator.publish( "moveCategoryOfAttribute", {
                            attributeID: attributeID,
                            oldIndex: catIndex,
                            newIndex: newIndex
                        })}, dragInfo.animationTimeMS ); // give time for animation to complete
                } else {
                    // drag ended in about the same position, redraw to original pos. to clean up view
                    dragInfo.view.moveCategoriesToDragPosition( oldY, catIndex, catIndex, dragInfo, true );
                }
                this.data( 'inDrag', false );
                // revert to pointer cursor, undoing startDragCategory() change
                this.attr('cursor', Dyn.plotUtil.cursorPointer );
            } else {
                // for not draggable categories like missing value, handle click
                dragInfo.view.clickCategory.call( this, event );
            }
            Dyn.plotUtil.safeStopPropogation( event );
        }

        dragMoveCategory( dx, dy, x, y, event ) {
            // drag event callback, this===dragged element created by createCategorySquareAndText()
            if( this.data('inDrag') ) {
                let dragInfo = this.data('dragInfo'),
                    newY = this.data('y0') + dy,
                    catIndex = this.data('catIndex'),
                    newIndex = dragInfo.getCategoryIndexFromDelta( catIndex, dy );
                this.data('newIndex', newIndex ); // save for dragEndCategory()
                dragInfo.view.moveCategoriesToDragPosition( newY, catIndex, newIndex, dragInfo );
                // maintain double-arrow cursor while dragging
                //event.currentTarget.style.cursor = Dyn.plotUtil.cursorVerticalBothSide;
            }
            Dyn.plotUtil.safeStopPropogation( event );
        }

        /** move the given attribute category to the new position,
         * and move the other categories in the legend out of the way.
         * @param v -- new position in Y of dragged category
         * @param oldIndex -- original (pre-drag) index of dragged category (in list of the attribute's categories)
         * @param newIndex -- new index of dragged category
         * @param dragInfo {{Dyn.DragCategoryUtil}} -- drag information (shared by all categories)
         * @param finalAnimation {boolean} -- true if we want dragged category to animate to new position
         */
        moveCategoriesToDragPosition( v, oldIndex, newIndex, dragInfo, finalAnimation ) {
            let catSets = this.attributeLegend[0]; // sets created by createCategorySquareAndText()
            catSets.forEach( (set ) => {
                // NOTE: with scroll bars, not all categories are in the set of visible elements. This is OK, we just
                // need to move the visible categories. Because of this, set index !== category index.
                let setIndex = 0, // get the 2 or 3 elements in the set
                    backgroundEl = set[0].data('selected') ? set[setIndex++] : null, // backgroundEl only if selected
                    textElem = set[setIndex++],
                    colorSquare = set[setIndex++],
                    catIndex = textElem.data('catIndex'),
                    dragInfo = textElem.data('dragInfo');
                if( catIndex === oldIndex && ! finalAnimation ) {
                    // move visible category to the mouse position
                    v = dragInfo.getLimitedDragPosition( v );
                    backgroundEl?.attr('y', v+dragInfo.backgroundVOffset );
                    textElem.attr( 'y', v );
                    colorSquare.attr('y', v+dragInfo.squareVOffset );
                } else {
                    // reposition other categories out of the way (leave a blank line where dragged category will go)
                    let ci2 = dragInfo.getCategoryIndexWithSkipping( catIndex, oldIndex, newIndex ),
                        y = dragInfo.cat0Coord+(dragInfo.catOffset*ci2);
                    backgroundEl?.animate( { 'y': y+dragInfo.backgroundVOffset }, dragInfo.animationTimeMS, dragInfo.animationEasing );
                    textElem.animate( { 'y': y }, dragInfo.animationTimeMS, dragInfo.animationEasing );
                    colorSquare.animate( { 'y': y+dragInfo.squareVOffset }, dragInfo.animationTimeMS, dragInfo.animationEasing );
                }
            });
        }

        handleCasesSelected( data ) {
            // hide marquee select if no longer selecting by numeric range
            Dyn.plotUtil.showOrHideElement( this.marqueeSelectRect, data.isNumericRangeChange );
        }

        /** handle an update to the legend attribute's data or metadata. */
        handleAttributeUpdate() {
            this.needsLegendUpdate = true;
        }

        setPlotSpecificOptions( options ) {
            var hadPlusMinus = this.isUsingPlusMinus,
                hadNumericIntervals = this.isUsingNumericIntervals,
                hadDisabledAttribute = this.isDisabledAttribute,
                hadIncompleteAxisStyle = this.isIncompleteAxisStyle;

            if( !options ) options = {};

            this.isUsingPlusMinus = Boolean(options.showPlusMinus);
            this.isUsingNumericIntervals = Boolean(options.useNumericIntervals);
            this.isDisabledAttribute = Boolean(options.disableAttribute);
            this.setIncompleteAxis(options.isIncompleteAxisStyle);

            // if any flags have changed then update the legend
            if( !this.needsLegendUpdate ){
                this.needsLegendUpdate = (
                    this.isUsingPlusMinus !== hadPlusMinus
                    || this.isUsingNumericIntervals !== hadNumericIntervals
                    || this.isDisabledAttribute !== hadDisabledAttribute);
            }
            if( !this.needsVisualsUpdate ){
                this.needsVisualsUpdate = (
                    this.isIncompleteAxisStyle !== hadIncompleteAxisStyle);
            }

            this.plusButton?.getCoverElement().data("isEnabled", ! options.disablePlusButton );
            this.minusButton?.getCoverElement().data("isEnabled", ! options.disableMinusButton );
            if( options.plusButtonTip ) {
                this.plusButton?.data('tooltip', options.plusButtonTip ); // update from makePlusMinusButton()
                this.plusButton?.getCoverElement().node.setAttribute( "aria-label", options.plusButtonTip );
            }
            if( options.minusButtonTip) {
                this.minusButton?.data('tooltip', options.minusButtonTip ); // update from makePlusMinusButton()
                this.minusButton?.getCoverElement().node.setAttribute( "aria-label", options.minusButtonTip );
            }
        }

        /**
         * update our view after changes
         * from Dyn.PlotElement.CalcAxis() or Dyn.PlotShaper.updateAxes()
         */
        postCalcAxisUpdate() {
            // Update the legend if the attribute has changed, or the stats have changed
            // console.log("MarginViewView:postCalcAxisUpdate()");
            var legendStatsUpdated = this.getAttribute() && this.getAttribute().updateStatsIfDataChange(),
                legendAttributeNotChanged = ( this.getAttribute() === Dyn.dataSet.getSelectedAttribute());
            if( this.needsVisualsUpdate ) {
                this.updateVisuals(); // update everything; clears needsVisualsUpdate
            } else if( this.needsLegendUpdate || (legendStatsUpdated && legendAttributeNotChanged )) {
                // update attribute name and legend only; clears needsLegendUpdate
                this.setSelectedAttributeLegend( Dyn.dataSet.getSelectedAttribute() );
            }
        }

        /** is the given attribute used in the legend? */
        isAttributeInUse( attributeID ) {
            return this.attribute && this.attribute.id === attributeID;
        }

        showHideBoundaryLine() {
            let showLine = this.dragLine.data("inDrag") || this.dragLine.data("inHover")
                || this.bubbleDropArea.wantExpanded() || this.colorDropArea.wantExpanded( this.attribute);
            Dyn.plotUtil.showOrHideElement( this.boundaryLine, showLine );
            Dyn.plotUtil.showOrHideElement( this.dragLine, showLine );
        }

        setExcludedCasesHeight( height ) {
            this.orderDropArea.setExcludedCasesHeight( height );
        }

        /** add to the plot summary array, information about this legend */
        getPlotSummary() {
            let plotSummary = [];
            if( this.attribute !== null ){
                plotSummary.push(Dyn.stringFormat(Dyn.plotUtil.legendSummary,
                    this.attribute.getDataType(),
                    this.attribute.name));
                if (this.attribute.getDataType() === 'numerical'){
                    plotSummary.push(Dyn.stringFormat(Dyn.plotUtil.numericalLegendAttributeSummary,
                        this.attribute.stats.min,
                        this.attribute.stats.max));
                } else {
                    plotSummary.push(Dyn.stringFormat(Dyn.plotUtil.categoricalLegendAttributeSummary,
                        this.attribute.stats.categories.length,
                        this.attribute.stats.categories.length,
                        this.attribute.stats.categories.join(', ').replace(/, ([^,]*)$/, ' and $1')));
                }
                if(this.attribute.stats.missingCaseCount !== 0){
                    plotSummary.push(Dyn.stringFormat(Dyn.plotUtil.missingCaseLegendSummary,
                        this.attribute.name));
                }
            } else {
                plotSummary.push(Dyn.stringFormat(Dyn.plotUtil.noLegendSummary));
            }
            return plotSummary.join(' ');
        }

        // static constants
        static legendBorderColor = "#555"; // visible right-hand border line color for legend
        static legendCoverColor = "#FFFFFF"; // invisible but wide-enough-to-drag border line cover
        static legendCoverOpacity = Dyn.plotUtil.opacityInvisibleButDraggable;
        static legendCoverHighlightColor = "red";
        static legendCoverHighlightOpacity = 0.1; // combine with red to make final pale-red highlight color
        static marqueeMargin = 2;

    } // class RightMarginView
    Dyn.RightMarginView = RightMarginView;

}; // wrapDynRightMarginView
